import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { RouteComponentProps } from "react-router-dom";
import {
  CNIC_VERIFITCATION_USER_TYPE,
  CREDIT_USER_STATUS,
  OWNER_VERIFICATION_STATUS,
} from "config/constants";
import { CUSTOMER_CHANNEL } from "../config/constants";
import { DELIVERY_DATE_STATUS } from "components/pages/deliveryDate/DeliveryDatePage.constants";
import { IPageType, IUpdatePromoPayload } from "./userLevelPromo.interface";
import { ReactNode } from "react";
import { ICreditUserStatusResponse } from "./credit.interface";
import { PromoType } from "components/pages/PromosCityLevel/constants/AddBulkPromosCityLevelConstats";

export interface IButtonProps {
  buttonClass?: string;
  buttonText: string | any;
  // onClickHandler?: (e: any, param2?: any) => void | {};
  onClickHandler?: any;
  buttonStyles?: object;
  classAtr?: string;
  isDisable?: boolean;
}

export interface IKeycloakAuthExchangeRequestPayload {
  authorizationCode: string;
  redirectUri: string;
  clientId: string;
  bazaarClientName: string;
}

export interface IGetCustomerNewDetailResponse {
  accountStatus: string;
  countryCode: string;
  fullName: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
  email: string;
  organizationId: string;
}

export interface IAddUpdateCustomerPageProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCustomerAdded: boolean;
  customer: IcreateUserPayload | null;
  fetchCustomersZoneApi: (queryParams?: IGetZoneParams) => void;
  createCustomer: (payload: IcreateUserPayload) => void;
  updateCustomer: (payload: IcreateUserResponse) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, passwordReset?: any) => void | {};
  iscustomerDetailsNewFetched?: boolean;
  customerZones: any;
  customerDetailsNew: INewCustomerDetailResponseObject;
  getCustomerDetailsNew: (id: string) => void | {};
  clearCustomerDetailsNewAction: () => void | {};
  isCustomerUpdated?: boolean;
  dummyZoneId?: string;
  searchText?: string | number;
  createStore: (payload: IcreateUserPayload, id: string) => void;
  dummyIsCustomerFound?: boolean;
  fetchStoreType: () => void;
  storeType: ISelectDropdownOption;
  registrationType: boolean;
  incomeTaxStatus: boolean;
}

export interface IAddUpdateAccessControlPageProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isAccessControlUserAdded: boolean;
  accessControlUser: IAccessControlUserResponseObject | null;
  getAllRolesAndClients: () => void;
  createUserClientAndRoles: (
    payload: ICreateUpdateAccessControlUserNormalizedReq
  ) => void;
  updateUserClientAndRoles: (
    payload: ICreateUpdateAccessControlUserNormalizedReq
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, passwordReset?: any) => void | {};
  clearAccessControlUserLevelDetails: () => void;
  isaccessControlUserDetailsNewFetched?: boolean;
  accessControlUserDetailsNew: INewAccessControlUserDetailResponseObject;
  getAccessControlUserDetailsNew: (id: string) => void | {};
  isAccessControlUserUpdated?: boolean;
  allClientsRoles: IClientsResponseObject[] | null;
  isAllClientsRolesFetched: boolean;
  userInfo: ILoginUserInfo;
  testClients?: IClientsResponseObject[];
  testClientRoles?: IRolesResponseObject[];
  filters: Array<any>;
  isAllFiltersFetched: boolean;
  fetchAllFilters: () => void;
}

export interface IAddUpdateCustomerPageState {
  [key: string]: any;
}

export interface IAddUpdateAccessControlPageState {
  accountStatus?: string;
  countryCode?: string;
  fullName: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
  email: string;
  password: string;
  clients: Array<IClientsResponseObject>;
  roles: Array<IRolesResponseObject>;
  status: string | boolean;
  resetPasswordModal?: boolean | any;
  filters: Array<IFilterPayload>;
  organizationId?: any;
}

export interface ICreateUpdateAccessControlUserNormalizedReq {
  id?: string;
  accountStatus?: string;
  countryCode?: string;
  fullName: string;
  nationalId: string;
  phoneNumber: string;
  email: string;
  password?: string;
  confirmPassword?: string;
  clientIds: Array<string>;
  roleIds: Array<string>;
  status?: string;
  filters: Array<IFilterPayload>;
  organizationId?: any;
}

export interface IOrganizationId {
  id: "string";
  label: "string";
}

export interface IPartnerChannel {
  partnerId: string;
  customerChannel: string;
  zoneId: string;
}

export interface ICustomerPageProps extends RouteComponentProps {
  fetchCustomers: (queryParams?: IGetQueryParams) => void;
  fetchCustomersZoneApi: (queryParams?: IGetZoneParams) => void | {};
  createCustomer: (payload: IcreateUserPayload) => void;
  clearCustomerDetailsNewAction: () => void | {};
  getCustomerDetailsNew: (id: string) => void | {};
  updateCustomer: (payload: IcreateUserResponse) => void;
  customers: null | Array<ICustomerPageState>;
  pagination: any;
  isFetchCustomerLoading: boolean;
  isFetchCustomerError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isCustomerAdded: boolean;
  isCustomerUpdated: boolean;
  customerDetailsNew: INewCustomerDetailResponseObject;
  customerZones: any;
  createStore: (payload: IcreateUserPayload, id: string) => void;
  fetchStoreType: () => void;
  storeType: ISelectDropdownOption;
  incomeTaxStatus: boolean;
  registrationType: boolean;
}

export interface IAccessControlUserPageProps extends RouteComponentProps {
  fetchAccessControlUsers: (queryParams?: IGetQueryParams) => void;
  createAccessControlUser: (payload: IcreateAccessControlUserPayload) => void;
  getAccessControlUserDetailsNew: (id: string) => void | {};
  updateAccessControlUser: (payload: IcreateUserResponse) => void;
  getAllRolesAndClients: () => void;
  clearAccessControlUserLevelDetails: () => void;
  createAccessControlUserWithClientAndRoles: (
    payload: ICreateUpdateAccessControlUserNormalizedReq
  ) => void;
  updateAccessControlUserWithClientAndRoles: (
    payload: ICreateUpdateAccessControlUserNormalizedReq
  ) => void;
  accessControlUsers: null | Array<IAccessControlUsersNormalized>;
  pagination: any;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isAccessControlUserAdded: boolean;
  isAccessControlUserUpdated: boolean;
  accessControlUserDetailsNew: INewAccessControlUserDetailResponseObject;
  allClientsRoles: IClientsResponseObject[] | null;
  isAllClientsRolesFetched: boolean;
  userInfo: ILoginUserInfo;
  filters: Array<any>;
  isAllFiltersFetched: boolean;
  fetchAllFilters: () => void;
}

export interface ICustomerPageState {
  [key: string]: any;
}

export interface IAccessControlPageState {
  [key: string]: any;
}

export interface IAccessControlUsersNormalized {
  id: string;
  fullName: string;
  phoneNumber: string;
  cnicNumber: string;
  email: string;
  status: string;
  countryCode: string;
  roles: Array<any>; // TO-DO: Define these
  clients: Array<any>; // TO-DO: Define these
  filters: Array<any>;
}

export interface IAccessControlUserInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isAccessControlUserAdded: boolean;
  accessControlUsers: null | Array<IAccessControlUsersNormalized>;
  pagination: any;
  accessControlUserDetailsNew: INewAccessControlUserDetailResponseObject | null;
  isaccessControlUserDetailsNewFetched: boolean;
  isAccessControlUserUpdated: boolean;
  allClientsRoles: null | IClientsResponseObject[];
  isAllClientsRolesFetched: boolean;
  isAllFiltersFetched: boolean;
  filters: IDropDownResponse[] | null;
}

export interface ICustomerInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCustomerAdded: boolean;
  isFetchCustomerLoading: boolean;
  isFetchCustomerError: boolean;
  customers: null | Array<any>;
  pagination: any;
  customerDetailsNew: INewCustomerDetailResponseObject | null;
  bulkCustomerDetails: Map<string, INewCustomerResponseObject> | null;
  iscustomerDetailsNewFetched: boolean;
  customerZones: any;
  isBulkCustomerDetailsFetched: boolean;
  isCustomerUpdated: boolean;
  storeType: [];
  customerConfig: ICustomerConfigResponse | null;
  registrationType: boolean;
  incomeTaxStatus: boolean;
}

export interface IActionType {
  type: string;
  payload?: null | Array<any> | string | object;
  error?: string | object | null;
}

export interface IcreateUserPayload {
  [key: string]: string | object | number | Array<any> | null;
}

export interface IcreateAccessControlUserPayload {
  id: string;
  fullName: string;
  phoneNumber: string;
  nationalId: string;
  password: string;
  confirmPassword: string;
}

export interface IUser {
  id: string;
  userId: string;
}

export interface IAddress {
  id: string;
  address: string;
  latitude: number;
  longitude: number;
  zoneId: string;
  selectedCityId?: string;
}

export interface INewCustomerResponseObject {
  address: IAddress;
  id: string;
  name: string;
  ownerName: string;
  phoneNumber: string;
  status: string;
  userStatus?: string;
  storeType: string;
  user: IUser;
  customerChannel: string;
  incomeTaxStatus: string;
  registrationType: string;
  ntn: string;
  partnerChannels?: IPartnerChannel[];
}

export interface INewAccessControlUserResponseObject {
  clients: Array<any>;
  roles: Array<any>;
  user: IAccessControlUserResponseObject;
  filters: IFilterPayload[];
}

export interface IAccessControlUserResponseObject {
  accountStatus: string;
  countryCode: string;
  fullName: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
  email: string;
  clients: Array<IClientsResponseObject>;
  roles: Array<IRolesResponseObject>;
  status: string;
  password?: string;
  confirmPassword?: string;
  filters: Array<IFilterPayload>;
  organizationId?: string;
}

export interface INewCustomerDetailResponseObject {
  accountStatus: string;
  countryCode: string;
  fullName: string;
  email?: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
}

export interface ICustomerZoneResponseObject {
  id: string;
  name: string;
}

export interface INewAccessControlUserDetailResponseObject {
  accountStatus: string;
  countryCode: string;
  fullName: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
}

export interface IcreateUserResponse {
  [key: string]: string | object | number | Array<any>;
}

export interface IcreateAccessControlUserResponse {
  [key: string]: string | object | number | Array<any>;
}

export interface ILink {
  id?: number;
  isActive?: boolean;
  icon?: IconDefinition;
  img?: string;
  url: string;
  name: string;
  isEnable: boolean;
  childNav: Array<IChildNav>;
}

export interface IUpdatePassword {
  password: string;
  passwordConfirmation: string;
}

export interface IChildNav {
  isActive: boolean;
  url: string;
  img: string;
  name: string;
}

export interface IListProps {
  selectRow?: () => {};
  id?: string;
  store?: string;
  customer?: string;
  contact?: string;
  fetchCustomers: (queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedCustomer?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  customers: null | ICustomerPageState;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  isCustomerAddedorUpdated: boolean;
  error: null | string | object;
  isCustomerAdded: boolean;
  isCustomerUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
  passwordReset: any;
}

export interface IAccessControlUserListProps {
  selectRow?: () => {};
  id?: string;
  store?: string;
  accessControlUser?: string;
  contact?: string;
  fetchAccessControlUsers: (queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedAccessControlUser?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  accessControlUsers: null | Array<IAccessControlUsersNormalized>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  isAccessControlUserAddedorUpdated: boolean;
  error: null | string | object;
  isAccessControlUserAdded: boolean;
  isAccessControlUserUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
  userInfo: ILoginUserInfo;
  testAccessControlUserStateData?: any;
  passwordReset: any;
}

export interface ILoginProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  userAuth: null | ILoginState;
  mfa: null | IMFASessionResponseNormalized;
  isValidateMFASuccess: boolean;
  asyncLogin: (payload: IloginRequestPayload) => void;
  getMfaSession: (payload: IMFASessionPayload) => void;
  validateMfaSession: (payload: IMFASessionValidatePayload) => void;
  loginWithOidcProvider: (payload: IMFASessionValidatePayload) => void;
  mfaFallbackSession: (payload: IMFAFallbackPayload) => void;
  validateKeycloakSessionAction: (
    payload: IKeycloakAuthExchangeRequestPayload
  ) => void;
}

export interface ILoginState {
  email: string;
  PASSWORD: string;
  OTP: string;
  currentStep: number;
  whatsappBtn: number;
  showPhoneLogin: boolean;
  [key: string]: string | number | boolean;
}

export interface ILoginPageLayoutProps {}

export interface IAuthInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  auth: null | object;
  scopes: IAbilityScopes[] | null;
  userInfo: ILoginUserInfo | null;
  mfa: IMFASessionResponseNormalized | null;
  isValidateMFASuccess: boolean;
  roles: any[];
}

export interface IAbilityScopes {
  subject: string;
  action: string;
  conditons?: IAbilitySelf;
}

interface IAbilitySelf {
  userId: string;
}

export interface IloginRequestPayload {
  username: string | number;
  password: string | number;
}

export interface IRenewAccessTokenPayload {
  username: string;
  token: string;
}

export interface IRenewAccessTokenOIDCPayload {
  bazaarClientName: string;
  clientId: string;
  refreshToken: string;
}

export interface IMFASessionValidatePayload {
  token: string;
  factorData: string;
  clientInfo: IClientInfo;
}

export interface IMFAFallbackPayload {
  token: string;
  fallbackFactor: string;
}

export interface IClientInfo {
  androidVersion: string;
  appVersion: string;
  availableRam: string;
  availableStorage: string;
  totalRam: string;
  totalStorage: string;
  clientTime: string;
  clientTimeZone: string;
  deviceBrand: string;
  deviceId: string;
  deviceManufacturer: string;
  deviceModel: string;
  ipAddresses: [];
  competitorApps: [];
  socialMediaApps: [];
  isWifiEnabled: string;
  screenDpi: string;
  screenHeight: string;
  screenWidth: string;
}

export interface IMFASessionPayload {
  username: string;
}

export interface IMFASessionResponse {
  token: string;
  mfaSteps: IMFASteps[];
}

export interface IMFASteps {
  name: string;
  fallbacks: IMFAFallbacks[];
}

export interface IMFAFallbacks {
  name: string;
}

export interface IMFASessionResponseNormalized {
  token: string;
  factors: IMFASteps[];
}

export interface IMFASessionValidateResponse {
  mfaToken: string;
}

export interface IMFAFallbackResponse {
  mfaToken: string;
}

export interface IloginResponse {
  token: string;
  legacyToken: string;
  scopes: any[];
  userInfo: ILoginUserInfo;
  refreshToken: string;
  expiresAt?: string;
  accessToken: string;
  roles: any[];
}

export interface IAuth {
  token: string | null;
  expiresAt: string | null;
  refreshToken: string | null;
}

export interface ILoginResponseNormalized {
  auth: IAuth;
  isLoggedIn: boolean;
  scopes: IAbilityScopes[];
  userInfo: ILoginUserInfo;
  roles: any[];
  isOIDC?: boolean;
}

export interface ILoginUserInfo {
  id: string;
  fullName: string;
  phoneNumber: string;
  nationalId: string;
  countryCode: string;
  accountStatus: string;
  organizationId?: string;
  email: string;
}

export interface IDropdownButton {
  dropdownItem?: Array<IDropdownButtonList>;
  dropDownButtonText: string | ReactNode;
  onClickHandleButtonOne?: (e: any) => void | {};
  classNames?: string;
}

export interface IDropdownButtonList {
  id: number | string;
  buttonName: string;
  clickHandler: (e: any, param?: any) => void;
  key?: string;
}

export interface IGetQueryParams {
  pageInfo?: string | null;
  pageSize?: string | null;
  status?: string | null;
  criteria?: string | null;
  page?: string | null;
  size?: string | null;
  searchKey?: string | null;
  sortColumn?: string | null;
  sortDirection?: string | null;
  channel?: string | null;
  tourNumber?: string | null;
  phoneNumber?: string | null;
  riderId?: string | null;
  zoneType?: string | null;
  zoneId?: string | null;
  categoryId?: string | null;
  city?: string | null;
  pageNo?: string | null;
  cityId?: string | null;
  userId?: string | null;
  orderNumbers?: string | null;
  giftType?: string | null;
  customerChannel?: string | null;
}

export interface IGetZoneParams {
  latitude?: string | null;
  longitude?: string | null;
  customerType?: string | null;
}

export interface IGetCityParams {
  zoneType?: string | null;
}
export interface IGetWarehouseParams {
  cityId?: string | null;
}

export interface IMultiSelectDropdown {
  label: string;
  options: object;
  selectedValues?: any;
  groupBy?: string;
  showCheckbox?: boolean;
  placeholder?: any;
  displayValue: string;
  isDisable?: boolean;
  hidePlaceholder?: boolean;
  onChange: (e: any) => void;
  onRemove: (e: any) => void;
  className?: string;
}

export interface IProductPageProps extends RouteComponentProps {
  fetchProducts: (queryParams?: IGetQueryParams) => void;
  createProduct: (payload: FormData) => void;
  updateProduct: (id: string, payload: FormData) => void;
  fetchProductTypes: () => void;
  fetchProductUom: () => void;
  bulkUploadProduct: (payload: FormData, url: string) => void;
  inventoryUploadProduct: (payload: FormData, url: string) => void;
  getProductDetails: (id: string) => void;
  clearProductDetails: () => void;
  getCommandoCategories: (
    isProductDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  uploadImageAndCreateUpdateProductAction: (
    payload: FormData,
    jsonData: any,
    id: string
  ) => void;
  products: Array<IProductPayload>;
  pagination: any;
  isFetchProductLoading: boolean;
  isFetchProductError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isProductAdded: boolean;
  isProductUpdated: boolean;
  isProductBulkUploaded: boolean;
  isProductBulkUploading: boolean;
  isProductBulkUploadingError: boolean;
  isProductInventoryUploaded: boolean;
  isProductInventoryUploading: boolean;
  isProductInventoryUploadingError: boolean;
  productDetails: IProductPayload;
  isProductDetailsFetched: boolean;
  commandoProductCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  productTypes: Array<any>;
  productUomList: Array<any>;
  fetchProductBrands: () => void;
  productBrands: Array<any>;
  fetchWareHouseNames: () => void;
  wareHouseNames: Array<IWarehousePayload>;
  fetchProductInventory: (id: string) => void;
  productInventory: IProductInventory[];
  updateProductInventory: (id: string, payload: FormData) => void;
  isProductInventoryUpdated: boolean;
  isProductInventoryFetched: boolean;
  odooTax: null | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  fetchTaxFromOdoo: (id?: string) => void;
  productOptionalProperties: IProductOptionalProperties;
}

export interface IGlobalProductPageProps extends RouteComponentProps {
  fetchProducts: (queryParams?: IGetQueryParams) => void;
  updateGlobalProduct: (id: string, payload: FormData) => void;
  fetchProductTypes: () => void;
  fetchProductUom: () => void;
  bulkUploadProduct: (payload: FormData, url: string) => void;
  inventoryUploadProduct: (payload: FormData, url: string) => void;
  getProductDetails: (id: string) => void;
  getGlobalProductDetails: (id: string) => void;
  clearProductDetails: () => void;
  getCommandoCategories: (
    isProductDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  uploadImageAndCreateUpdateGlobalProductAction: (
    payload: FormData,
    jsonData: any,
    id: string
  ) => void;
  products: Array<IGlobalProductPayload>;
  pagination: any;
  isFetchProductLoading: boolean;
  isFetchProductError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isProductAdded: boolean;
  isProductUpdated: boolean;
  isProductBulkUploaded: boolean;
  isProductBulkUploading: boolean;
  isProductBulkUploadingError: boolean;
  isProductInventoryUploaded: boolean;
  isProductInventoryUploading: boolean;
  isProductInventoryUploadingError: boolean;
  productDetails: IGlobalProductPayload;
  isProductDetailsFetched: boolean;
  commandoProductCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  productTypes: Array<any>;
  productUomList: Array<any>;
  fetchProductBrands: () => void;
  productBrands: Array<any>;
  fetchWareHouseNames: () => void;
  wareHouseNames: Array<IWarehousePayload>;
  fetchProductInventory: (id: string) => void;
  productInventory: IProductInventory[];
  updateProductInventory: (id: string, payload: FormData) => void;
  isProductInventoryUpdated: boolean;
  isProductInventoryFetched: boolean;
  odooTax: null | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  fetchTaxFromOdoo: (id?: string) => void;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  fetchCustomerConfig: () => void;
  customerConfig: ICustomerConfigResponse;
  isCityListFetched: boolean;
  productOptionalProperties: IProductOptionalProperties;
}

export interface IStoreListingPageProps extends RouteComponentProps {
  fetchStoreListings: (queryParams?: IGetQueryParams) => void;
  createStoreListing: (payload: FormData) => void;
  updateStoreListing: (id: string, payload: FormData) => void;
  bulkUploadStoreListing: (payload: FormData, url: string) => void;
  getStoreListingDetails: (id: string) => void;
  clearStoreListingDetails: () => void;
  storeListings: Array<IStoreListingPayload>;
  pagination: any;
  isFetchStoreListingLoading: boolean;
  isFetchStoreListingError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isStoreListingAdded: boolean;
  isStoreListingUpdated: boolean;
  isStoreListingBulkUploaded: boolean;
  isStoreListingBulkUploading: boolean;
  isStoreListingBulkUploadingError: boolean;
  storeListingDetails: IStoreListingPayload;
  isStoreListingDetailsFetched: boolean;
}

export interface IGlobalProductListProps {
  fetchProducts: (queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedProduct?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  uploadBulkProduct: (payload: FormData, url: string) => void;
  uploadInventoryProduct: (payload: FormData, url: string) => void;
  products: Array<IProductPayload> | any;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  isProductAddedorUpdated: boolean;
  error: null | string | object;
  isProductBulkUploaded: boolean;
  isProductBulkUploading: boolean;
  isProductBulkUploadingError: boolean;
  isProductInventoryUploaded: boolean;
  isProductInventoryUploading: boolean;
  isProductInventoryUploadingError: boolean;
  isProductAdded: boolean;
  isProductUpdated: boolean;
  retainedSearchText: string;
  currentListPosition: number;
  testIsSearchProp?: boolean;
}

export interface IStoreListingListProps {
  uploadBulkStoreListing: (payload: FormData, url: string) => void;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isStoreListingBulkUploaded: boolean;
  isStoreListingBulkUploading: boolean;
  isStoreListingBulkUploadingError: boolean;
}

export interface IAddUpdateProductProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isProductAdded: boolean;
  product: IProductPayload;
  createProduct: (payload: FormData) => void;
  updateProduct: (id: string, payload: FormData) => void;
  getProductDetails: (id: string) => void;
  clearProductDetails: () => void;
  uploadImageAndCreateUpdateProductAction: (
    payload: FormData,
    jsonData: any,
    id: string
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  isProductUpdated: boolean;
  fetchProductTypes: () => void;
  fetchProductUom: () => void;
  productDetails: IProductPayload;
  isProductDetailsFetched: boolean;
  getCommandoCategories: (
    isProductDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  commandoProductCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  productTypes: Array<any>;
  productUomList: Array<any>;
  fetchProductBrands: (queryParams: IGetQueryParams) => void;
  productBrands: Array<any>;
  dummyValidations?: boolean;
  fetchWareHouseNames: () => void;
  wareHouseNames?: Array<IWarehousePayload>;
  fetchProductInventory: (id: string) => void;
  productInventory: IProductInventory[];
  updateProductInventory: (id: string, payload: any) => void;
  isProductInventoryFetched: boolean;
  odooTax: null | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  fetchTaxFromOdoo: (id?: string) => void;
  productOptionalProperties: IProductOptionalProperties;
}

export interface IGlobalAddUpdateProductProps extends RouteComponentProps {
  mockCities?: { id: string; name: string }[];
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isProductAdded: boolean;
  product: IGlobalProductPayload;
  updateGlobalProduct: (id: string, payload: FormData) => void;
  getProductDetails: (id: string) => void;
  getGlobalProductDetails: (id: string) => void;
  clearProductDetails: () => void;
  uploadImageAndCreateUpdateGlobalProductAction: (
    payload: FormData,
    jsonData: any,
    id: string
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  isProductUpdated: boolean;
  fetchProductTypes: () => void;
  fetchProductUom: () => void;
  productDetails: IGlobalProductPayload;
  isProductDetailsFetched: boolean;
  getCommandoCategories: (
    isProductDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  commandoProductCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  productTypes: Array<any>;
  productUomList: Array<any>;
  fetchProductBrands: () => void;
  productBrands: Array<any>;
  dummyValidations?: boolean;
  fetchWareHouseNames: () => void;
  wareHouseNames?: Array<IWarehousePayload>;
  fetchProductInventory: (id: string) => void;
  productInventory: IProductInventory[];
  updateProductInventory: (id: string, payload: any) => void;
  isProductInventoryFetched: boolean;
  odooTax: null | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  fetchTaxFromOdoo: (id?: string) => void;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  fetchCustomerConfig: () => void;
  customerConfig: ICustomerConfigResponse;
  isCityListFetched: boolean;
}

export interface IAddUpdateStoreListingProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isStoreListingAdded: boolean;
  storelisting: IStoreListingPayload;
  getWarehouseCategories: () => void | {};
  createStoreListing: (payload: FormData) => void;
  updateStoreListing: (id: string, payload: FormData) => void;
  getStoreListingDetails: (id: string) => void;
  clearStoreListingDetails: () => void;
  uploadImageAndCreateUpdateStoreListingAction: (
    payload: FormData,
    jsonData: any,
    id: string
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  isStoreListingUpdated: boolean;
  fetchStoreListingTypes: () => void;
  fetchStoreListingUom: () => void;
  warehouseCategories: Array<IWarehouseCategory>;
  isWarehouseCategoriesFetched: boolean;
  storelistingDetails: IStoreListingPayload;
  isStoreListingDetailsFetched: boolean;
  getCommandoCategories: (
    isStoreListingDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  commandoStoreListingCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  storelistingTypes: Array<any>;
  storelistingUomList: Array<any>;
  fetchStoreListingBrands: () => void;
  storelistingBrands: Array<any>;
}

export interface IAddUpdateAccessControlProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isUserAdded: boolean;
  user: IAccessControlPayload;
  createUser: (payload: FormData) => void;
  updateUser: (id: string, payload: FormData) => void;
  getUserDetails: (id: string) => void;
  clearAccessControlUserLevelDetails: () => void;
  clearUserDetails: () => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  isUserUpdated: boolean;
  getUsers: () => void | {};
  users: Array<any>;
  isUsersFetched: boolean;
  userDetails: IAccessControlPayload;
  isUserDetailsFetched: boolean;
  getCommandoUsers: (queryParams: IGetQueryParams) => void;
  commandoUser: Array<ICategoryListingNormalizedData>;
  isFetchUserAccessLoading: boolean;
  isFetchUserError: boolean;
  commandoUserError: null | string | object;
}

export interface IAccessControlPayload {
  id?: string | number;
  fullName: string;
  phoneNumber: string;
  cnicNumber: string;
  password: string;
  confirmPassword: string;
}

export interface IAddUpdateOrderProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isOrderAdded: boolean;
  order: IOrderPayload;
  createOrder: (payload: FormData) => void;
  updateOrder: (id: string, payload: FormData) => void;
  getOrderDetails: (id: string) => void;
  clearOrderDetails: () => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  isOrderUpdated: boolean;
  orderDetails: IOrderPayload;
  isOrderDetailsFetched: boolean;
}

export interface IOrderPayload {
  id?: string | number;
  productSku: string;
  productTitle: string;
  productDescription: string;
  productCategories: string | Array<any> | IProductCategory;
  commandoProductCategories?: string | ICategoryListingNormalizedData;
  productTags?: Array<any>;
  productVendor: any;
  productStock: string;
  inventoryId: string;
  variantId?: string;
  productOriginalPrice: string;
  productDisplayPrice: string;
  status: string | boolean;
  continueSelling: string | boolean;
  productImage: IProductImage;
  isChecked?: boolean;
  productWeightValue: string;
  productWeightUnit: string;
}

export interface IProductPayload {
  id?: string | number;
  productSku: string;
  productTitle: string;
  productDescription: string;
  commandoProductCategories?: string | ICategoryListingNormalizedData;
  productTags?: Array<any>;
  productVendor: any;
  productStock?: string;
  inventoryId: string;
  variantId?: string;
  productOriginalPrice: string;
  productDisplayPrice: string;
  productRetailPrice: string;
  status: string | boolean;
  continueSelling: string | boolean;
  productImage: IProductImage;
  isChecked?: boolean;
  productWeightValue: string;
  productWeightUnit: string;
  productType: string | null;
  productUomPurchase: string | null;
  productUomStock: string | null;
  productUomSales: string | null;
  brand?: ISelectedBrand | string;
  channels?: any; // Will define the type of the channel later.
  sellingTax: string | ISelectedBrand;
  purchaseTax: string | ISelectedBrand;
  productOptionalProperties: IProductOptionalProperties;
}

export interface IGlobalProductPayload {
  id?: string | number;
  productSku: string | undefined;
  productTitle: string;
  productDescription: string | undefined;
  commandoProductCategories?: string | ISelectedBrand | undefined;
  productTags?: Array<any>;
  productVendor: any;
  productStock?: string | undefined;
  inventoryId: string | undefined;
  variantId?: string;
  productOriginalPrice: string | undefined;
  productDisplayPrice: string | undefined;
  productRetailPrice: string | undefined;
  status: string | boolean | undefined;
  continueSelling: string | boolean | undefined;
  productImage: IProductImage | undefined;
  isChecked?: boolean;
  productWeightValue: string | undefined;
  productWeightUnit: string;
  productType: string | null;
  productUomPurchase: string | null;
  productUomStock: string | null;
  productUomSales: string | null;
  brand?: ISelectedBrand | string;
  channels?: any; // Will define the type of the channel later.
  sellingTax: string | ISelectedBrand;
  purchaseTax: string | ISelectedBrand;
  cities: Array<ICitiesResponseObject>;
  customerChannels: Array<ISelectDropdownOption>;
  productBarcodePurchase: string;
  productBarcodeInventory: string;
  productBarcodeSales: string;
  optionalProperties: IProductOptionalProperties;
  purchase: IProductVariantProperties;
  sales: IProductVariantProperties;
  stock: IProductVariantProperties;
}

export interface IStoreListingPayload {
  id?: string | number;
  agent: string;
  lastUploaded: string;
  numberOfStoresAssigned: Array<any>;
}

export interface ISelectedBrand {
  brandId?: string;
  id?: string | null;
  value?: string | null;
  label?: string | null;
}

interface IProductImage {
  [key: string]: any;
}

export interface ISelectDropDownProps {
  id: string;
  label?: string;
  options: any;
  handleChange: (e: any) => void | {};
  value: any;
  defaultOption: IdefaultSelectValues;
  disabled?: boolean;
}

interface IdefaultSelectValues {
  id: string;
  value: string;
  text: string;
}

export interface ISwitchProps {
  name?: string;
  id?: string;
  label?: string;
  checked?: boolean;
  handleSwitch?: (e: any) => void | {};
  value?: string;
  statusVal1?: string;
  statusVal2?: string;
  disabled?: boolean;
}

export interface IProductCreatePayload {}

export interface IProductCategory {
  id: string;
  title: string;
  value?: string;
  key?: string;
  label?: string;
}

export interface IWarehouseCategory {
  id: string;
  title: string;
  value?: string;
  key?: string;
  label?: string;
  name?: string;
  storageBlocks?: IStorageBlock[];
}

export interface ISelectDropdownOption {
  id: string;
  title: string;
  value?: string;
  key?: string;
  label?: string;
  name?: string;
  isChecked?: boolean;
}

export interface IProductInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isProductAdded: boolean;
  isFetchProductLoading: boolean;
  isFetchProductError: boolean;
  products: Array<any>;
  pagination: any;
  isProductUpdated: boolean;
  isProductBulkUploaded: boolean;
  isProductBulkUploading: boolean;
  isProductBulkUploadingError: boolean;
  isProductInventoryUploaded: boolean;
  isProductInventoryUploading: boolean;
  isProductInventoryUploadingError: boolean;
  productDetails: IProductPayload | {};
  isProductDetailsFetched: boolean;
  productTypes: Array<any>;
  productUomList: [];
  productBrands: Array<any>;
  wareHouseNames: Array<IWarehousePayload>;
  productInventory: null | IProductInventoryPayload;
  isProductInventoryUpdated: boolean;
  isProductInventoryFetched: boolean;
  odooTax: null | IOdooTaxResponse | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  citiesList: IIdValuePairResponse[];
  productOptionalProperties: IProductOptionalProperties | {};
}

export interface IStoreListingInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isFetchStoreListingLoading: boolean;
  isFetchStoreListingError: boolean;
  isStoreListingBulkUploaded: boolean;
  isStoreListingBulkUploading: boolean;
  isStoreListingBulkUploadingError: boolean;
}

export interface IDataTableProps {
  tableId?: string;
  handleAllRecordSelection?: () => void;
  allRecordsChecked?: boolean;
  tableHeaderData?: Array<ITableHeaderProps> | null;
  tableFooterData?: ITableFooterProps | null;
  tableBodyDataTypes: Array<ITableBodyDataType>;
  tableBodyRowData: Array<ITableBodyProps>; // TO-DO: Define this after API integration
  checkBoxClickHandler?: (e: any, id?: any) => void;
  noSearchResultFlag?: boolean;
  editRowHandler?: (e: any, id?: any) => void;
}

export interface ITableHeaderProps {
  type?: string;
  text: string;
}

export interface ITableFooterProps {
  imgSrc?: string;
  imgAlt?: string;
  title?: string;
  subTtitle?: string;
}

interface ITableBodyDataType {
  type: string;
  key: string;
  imgAltTag?: string;
  other?: any;
  prepend?: string;
}

export interface ITableBodyProps {
  [key: string]: any;
}

export interface IDataTableSubTableProps {
  tableId?: string;
  handleAllRecordSelection?: () => void;
  allRecordsChecked?: boolean;
  tableHeaderData?: Array<IDataTableSubTableHeaderProps> | null;
  tableFooterData?: IDataTableSubTableFooterProps | null;
  tableBodyDataTypes: Array<IDataTableSubTableBodyDataType>;
  tableBodyRowData: Array<IDataTableSubTableBodyProps>; // TO-DO: Define this after API integration
  checkBoxClickHandler?: (e: any, id?: any) => void;
  noSearchResultFlag?: boolean;
  editRowHandler?: (e: any, outerIndex?: number, innerIndex?: number) => void;
}

export interface IDataTableSubTableHeaderProps {
  type?: string;
  text: string;
}

export interface IDataTableSubTableFooterProps {
  imgSrc?: string;
  imgAlt?: string;
  title?: string;
  subTtitle?: string;
}

interface IDataTableSubTableBodyDataType {
  type: string;
  key: string;
  imgAltTag?: string;
  other?: any;
  prepend?: string;
}

export interface IDataTableSubTableBodyProps {
  [key: string]: any;
}

export interface IModalProps {
  showModal: boolean;
  modalLoading?: boolean;
  isSuccess?: boolean;
  modalHeading?: string;
  totalRowUpload?: string;
  itemsUploaded?: string;
  failedRecords?: string;
  uploadComplete?: boolean;
  children?: any;
  showProgressString?: boolean;
  closeModalHandler?: () => void;
  childrenWrapper?: string;
  modalBodyClass?: string;
  containerClass?: string;
  showCloseButton?: boolean;
  closeModalOnBackgroundClick?: boolean;
}

export interface IUploadButtonComponent {
  id: string;
  buttonText: string;
  fileFormat: string;
  handleFileChange: (e: any) => void;
  handleRemoveFile?: (e: any) => void;
  helperText?: string;
  allowedFileSize?: number;
  allowedDimensions?: {
    width: number;
    height: number;
  };
  classes?: string;
  isDisable?: boolean;
  fileUploaded?: boolean;
}

export interface IRadioButtonProps {
  label: string;
  radioButtonArray: Array<IRadioButtonProperties>;
  onChange: (e: any, index: number) => void;
  isDisabled?: boolean;
}

export interface IRadioButtonProperties {
  name: string;
  checked: boolean;
  buttonText: string;
  value: string;
}

export interface ICategoryPayload {
  id?: string;
  categoryType: string;
  categoryFeature: string;
  categoryTitle: string;
  categoryDescription: string;
  status: string | boolean;
  coreCategory: ISelectedBrand | string;
  categoryImage: string | IImageObject;
  categoryImageId?: string;
  categoryHandle?: string;
}

export interface IImageObject {
  multiPartData?: File;
  base64StringUrl: string;
  fileError?: any;
}

export interface ISubCategory {
  id: string;
  title: string;
}

export interface ICategoryPageProps extends RouteComponentProps {
  // fetchCategories: (
  //   isProductDetailPage: boolean,
  //   queryParams?: IGetQueryParams
  // ) => void;
  // createCategory: (payload: any) => void;
  // getCoreCategories: () => void | {};
  // uploadCategoryImage: (payload: FormData) => Promise<any>;
  // uploadCategoryImageAndCreateCategory: (
  //   imgPayload: FormData,
  //   fieldPayload: ICreateCategoryPayload,
  //   isEdit: boolean
  // ) => void;
  // updateCategory: (id: string, payload: ICreateCategoryPayload) => void;
  // categories: Array<ICategoryListingNormalizedData[]>;
  // pagination: any;
  // isFetchCategoryLoading: boolean;
  // isFetchCategoryError: boolean;
  // error: null | string | object;
  // isLoading: boolean;
  // isError: boolean;
  // isCategoryAdded: boolean;
  // isCategoryUpdated: boolean;
  // coreCategories: Array<any>;
  // isCoreCategoriesFetched: boolean;
  // isCategoryImageUploading: boolean;
  // isCategoryImageUploaded: boolean;
  // SortableList: IProductByDisplayOrder;
  // isCategoryProductsFetched: boolean;
  // isCategoryProductsError: boolean;
  // categoryProducts: Array<ICategoryProductsResponse>;
  // fetchCategoryProduct: (id: string) => void;
  // updateCategoryProduct: (
  //   id: string,
  //   payload: ICategoryProductUpdatePayload
  // ) => void;
  // isCategoryProductsUpdated: boolean;
  // isProductBulkUploadingError: boolean;
}

export interface ICategoryListProps {
  fetchCategories: (
    isProductDetailPage: boolean,
    queryParams?: IGetQueryParams
  ) => void;
  // addUpdatePageHandler: (
  //   isEdit?: boolean,
  //   selectedCategory?: any,
  //   searchText?: string,
  //   currentScroll?: number
  // ) => void;
  // uploadBulkProduct: (payload: FormData) => void;
  categories: Array<ICategoryListingNormalizedData[]>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  // isCategoryAdded: boolean;
  // isCategoryUpdated: boolean;
  isCategoryAddedorUpdated: boolean;
  testIsSearchProp?: boolean;
  currentListPosition: number;
  retainedSearchText: string;
}

export interface IAddUpdateCategoryProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  // isCategoryAdded: boolean;
  category: ICategoryPayload;
  // createCategory: (payload: any) => void;
  // updateCategory: (id: string, payload: ICreateCategoryPayload) => void;
  uploadCategoryImage: (payload: FormData) => Promise<any>;
  uploadCategoryImageAndCreateCategory: (
    imgPayload: FormData,
    fieldPayload: ICreateCategoryPayload,
    isEdit: boolean
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  // isCategoryUpdated?: boolean;
  // getCoreCategories: () => void | {};
  coreCategories: Array<any>;
  isCoreCategoriesFetched: boolean;
  isCategoryImageUploading: boolean;
  isCategoryImageUploaded: boolean;
  fetchCategoryProduct: (id: string) => void;
  isCategoryProductsFetched: boolean;
  isCategoryProductsError: boolean;
  categoryProducts: Array<ICategoryProductsResponse>;
  updateCategoryProduct: (
    id: string,
    payload: ICategoryProductUpdatePayload
  ) => void;
  isCategoryProductsUpdated: boolean;
}

export interface IAddUpdateCategoryState {
  checkedStatus: boolean;
  selectedOption: boolean;
  showSubCategories: boolean;
}

export interface ICategoryCityListingResponse {
  id: string;
  handle: string;
  title: string;
  imageId: string;
  imageUrl: string;
  isEnabled: boolean;
  categoryFlag: string;
  children?: ICategoryCityListingResponse[];
}

export interface ICategoryListingResponse {
  id: string;
  title: string;
  description: string;
  enabled: boolean;
  categoryType: string;
  imageUrl?: string;
  imageId?: string;
  handle?: string;
}

export interface ICategoryListingNormalizedData {
  id: string;
  categoryHandle: string;
  categoryTitle: string;
  categoryImageId: string;
  categoryImage: string;
  categoryFlag: string;
  isEnabled: boolean;
  categoryType: string;
  parentId: string | null;
  title?: string;
  key?: string;
  label?: string;
  handle?: string;
  categoryDescription?: string;
  cities?: string[];
}

export interface ICategoryListingResponseAction {
  pagination: number | null;
  isPaginatedRes: boolean;
  categoriesData: ICategoryListingNormalizedData[][];
}

export interface ICreateCategoryPayload {
  id?: string;
  name: string;
  description: string;
  type: string;
  coreCategory?: ICoreCategory;
  enabled: number;
  imageId?: string;
  imageUrl?: string;
}

export interface ICategoryCityLevelPayload {
  categoryFlag: string;
  isEnabled: boolean;
  imageId: string;
}

export interface ICoreCategory {
  id: number | string;
  title: string;
  value?: string;
}

export interface ICategoryInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCategoryAdded: boolean;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  categories: null | Array<any>;
  pagination: any;
  coreCategories: Array<any>;
  isCoreCategoriesFetched: boolean;
  isCategoryUpdated: boolean;
  isCategoryImageUploading: boolean;
  isCategoryImageUploaded: boolean;
  isCategoryProductsFetched: boolean;
  isCategoryProductsError: boolean;
  categoryProducts: Array<ICategoryProductsResponse>;
  isCategoryProductsUpdated: boolean;
}

export interface IProductDetailsResponse {
  id: number;
  title: string;
  description: string;
  vendor: string;
  status: string;
  categoryId: string;
  variantId: number;
  sku: string;
  originalPrice: string;
  displayPrice: string;
  retailPrice: number;
  weight: IWeight;
  inventory: IInventory;
  imageId: number;
  imageUrl: string;
  productType: any;
  unitsOfMeasure: any;
  brand: any;
  customerApp: string | boolean;
  agentApp: string | boolean;
  adminCommando: string | boolean;
  channels: any;
  tax: IProductDetailTaxPayload;
  cities: any;
}

export interface IGlobalProductDetailsResponse {
  id: number;
  title: string;
  description: string;
  vendor: string;
  status: string;
  categoryId: string;
  variantId: number;
  sku: string;
  originalPrice: string;
  displayPrice: string;
  retailPrice: number;
  weight: IWeight;
  inventory: IInventory;
  imageId: number;
  imageUrl: string;
  productType: any;
  unitsOfMeasure: any;
  brand: any;
  customerApp: string | boolean;
  agentApp: string | boolean;
  adminCommando: string | boolean;
  channels: any;
  tax: IProductDetailTaxPayload;
  cities: Array<string>;
  customerChannels: Array<string>;
  barcodesDto: IBarcodePayload;
  optionalProperties: IProductOptionalProperties;
  purchase: IProductVariantProperties;
  sales: IProductVariantProperties;
  stock: IProductVariantProperties;
}

export interface IProductDetailTaxPayload {
  salesTaxId: string;
  purchaseTaxId: string;
  advanceTaxApplicable: boolean;
  furtherTaxApplicable: boolean;
}

export interface IBarcodePayload {
  purchase: string;
  stock: string;
  sales: string;
}

interface IInventory {
  inventoryItemId: number;
  stock: string;
  policy: string;
}

interface IWeight {
  value: number;
  unit: string;
}

export interface IProductUpdatePayload {
  title: string;
  description: string;
  status: string;
  categoryId: string;
  variantId: number;
  vendor: string;
  weight: IWeight;
  inventory: IInventory;
  originalPrice: string;
  displayPrice: string;
  imageId: number;
}

export interface IAsyncSelectProps {
  id: string;
  name?: string;
  placeHolderText: string;
  defaultAsyncOptions?: Array<IAsyncOptions>;
  loadAsyncOptions: (inputValue: any) => void;
  handleAsyncSelectChange: (selectedOption: any, action: any) => void;
  styles?: IAddUpdateCustomerPageState;
  isCustomSelectValue?: boolean;
  isDisabled?: boolean;
  isCreatable?: boolean;
}

interface IAsyncOptions {
  value: string;
  label: string;
}

export interface IOrderAddUpdateList {
  id: number | string;
  variantId: number;
  itemName: string;
  itemPrice: number;
  quantity: number;
  discount: number;
  isChecked?: boolean;
  productOriginalPrice?: number;
  additionalDiscount?: number;
  uomSale?: string;

  [key: string]: any;

  stock?: any;
  sku?: string;
  purchaseTaxId?: string;
  salesTaxId?: string;
  title?: string;
  imageUrl?: string;
  categoryId?: string;
  brandId?: string;
  retailPrice?: number;
}

export interface IAddUpdateOrdersState {
  id?: string;
  orderNumber: number | string;
  customerStore: string;
  customerNumber: string;
  customerAddress: string;
  customerId: number | string;
  customerNTN: string;
  customerChannel: string;
  partnerChannels?: IPartnerChannel[];
  orderDiscount?: number;
  orderList: IOrderAddUpdateList[];
  unitsAvailable?: number;
  // creditUserStatus: CREDIT_USER_STATUS;
}

export interface IZoneInfoState {
  cityId?: string;
  zoneId?: string;
  townId?: string;
  ucId?: string;
  zoneStatus?: boolean;
}

export interface IZoneDetailResponse {
  city: IIdValuePairResponse;
  zone: IIdValuePairResponse;
  town: IIdValuePairResponse;
  uc: IIdValuePairResponse;
}

export interface IOrderPageProps extends RouteComponentProps {
  fetchOrders: (queryParams?: IGetQueryParams) => void;
  createOrder: (payload: ICreateOrderPayload) => void;
  updateOrder: (id: string, payload: IUpdateOrderPayload) => void;
  updateOrderStatus: (id: string, payload: IUpdateOrderStatusPayload) => void;
  getPromosForOrder: () => void;
  getOrderPriceBreakdown: (queryPrams?: IGetQueryParams) => void;
  orderPriceBreakdown: IOrderPriceBreakdown | null;
  isOrderPriceBreakdownFetched: boolean;
  orders: Array<IFetchOrderNormalizedResponse>;
  pagination: any;
  isFetchOrderLoading: boolean;
  isFetchOrderError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isOrderCreated: boolean;
  isOrderUpdated: boolean;
  orderDetails: IOrderDetailResponseNormalized;
  isOrderDetailsFetched: boolean;
  isOrderStatusUpdated: boolean;
  getOrderDetails: (id: string) => void;
  clearOrderDetails: () => void;
  getBulkCustomerDetailsByIdAction: (ids: string[]) => void | {};
  bulkCustomerDetails: Record<string, IGetCustomerNewDetailResponse>;
  clearBulkCustomerDetailsNewAction: () => void | {};
  isPromosForOrderFetched: boolean;
  promosForOrder: IActivePromosForOrderPayload | null;
}

export interface IOrderListProps {
  fetchOrders: (queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedOrder?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  orders: Array<IFetchOrderNormalizedResponse>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isOrderCreated: boolean;
  isOrderUpdated: boolean;
  isOrderStatusUpdated: boolean;
  isOrderAddedorUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
}

export interface IAddUpdateOrderPageProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isOrderCreated: boolean;
  order: IAddUpdateOrdersState;
  createOrder: (payload: any) => void;
  updateOrder: (id: string, payload: IUpdateOrderPayload) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  isOrderUpdated: boolean;
  dummyProductDataProp?: Array<any>;
  dummyIsSearch?: boolean;
  testingOrderProp?: Array<IOrderAddUpdateList>;
  orderDetails: IOrderDetailResponseNormalized;
  isOrderDetailsFetched: boolean;
  isOrderStatusUpdated: boolean;
  getOrderDetails: (id: string) => void;
  clearOrderDetails: () => void;
  updateOrderStatus: (id: string, payload: IUpdateOrderStatusPayload) => void;
  getBulkCustomerDetailsByIdAction: (ids: string[]) => void;
  getPromosForOrder: () => void;
  getOrderPriceBreakdown: (queryPrams?: IGetQueryParams) => void;
  orderPriceBreakdown: IOrderPriceBreakdown | null;
  isOrderPriceBreakdownFetched: boolean;
  bulkCustomerDetails: Record<string, IGetCustomerNewDetailResponse>;
  clearBulkCustomerDetailsNewAction: () => void | {};
  isPromosForOrderFetched: boolean;
  promosForOrder: IActivePromosForOrderPayload | null;
}

export interface IOrderListComponentProps {
  orderList: Array<IOrderAddUpdateList>;
  handleChange: (e: any, indexSelected: number) => void;
  showDiscountModal?: (flag: boolean, indexSelected: number) => void;
  unitsAvailable?: any;
  handleStockValidationCheck?: any;
  orderStatus?: string;
}

export interface ICreateOrderCustomerPayload {
  id: number | string;
  storeName: string;
  phone: string;
  shippingAddress: string | null;
  zoneInfo?: IZoneInfoState;
  customerChannel: string;
}

export interface ICreateOrderDiscountPayload {
  type: string;
  value: number;
}

export interface ICreateOrderProductsPayload {
  id: number | string;
  name: string;
  type: string;
  unitPrice: number;
  quantity: number;
  discount: ICreateOrderDiscountPayload;
  uomSale: string;
  tax: ICreateUpdateOrderTaxPayload;
}

export interface ICreateUpdateOrderTaxPayload {
  id: string;
  taxType: string;
  amountType: string;
  amount: number;
}

export interface ICreateOrderPayload {
  customer: ICreateOrderCustomerPayload;
  items: ICreateOrderProductsPayload[];
  flatDiscount?: ICreateOrderDiscountPayload;
  promos?: IOrderPromoDiscountPayload[];
  partnerChannels: IPartnerChannel[];
  creditAmount?: number;
  planId?: string;
}

export interface IOrderPromoDiscountPayload {
  promoId: string;
  type: string;
  value: number;
  comments?: string;
}

export interface IUpdateOrderPayload {
  items: Array<ICreateOrderProductsPayload>;
  flatDiscount?: ICreateOrderDiscountPayload;
  promos?: IOrderPromoDiscountPayload[];
  deliveryDate?: number | any;
  deliveryType?: string;
  vehicleProvider?: string;
  partnerChannels: IPartnerChannel[];
}

export interface IUpdateOrderStatusPayload {
  status: string;
}

export interface IOrderInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isOrderCreated: boolean;
  orders: Array<any>;
  pagination: any;
  isOrderUpdated: boolean;
  isFetchOrderLoading: boolean;
  isFetchOrderError: boolean;
  orderDetails: any;
  isOrderDetailsFetched: boolean;
  isOrderStatusUpdated: boolean;
  isPromosForOrderFetched: boolean;
  promosForOrder: IActivePromosForOrderPayload | null;
  orderPriceBreakdown: IOrderPriceBreakdown | null;
  isOrderPriceBreakdownFetched: boolean;
  userCreditStatus: ICreditUserStatusResponse;
}

export interface IFetchOrderResponse {
  id: number;
  orderNumber?: number;
  date: string;
  storeName: string;
  total: number;
  channel: string;
  status: string;
  isLocked: boolean;
}

export interface IFetchOrderNormalizedResponse {
  id: number;
  orderNumber: number | string;
  orderDate: string;
  storeName: string;
  orderTotal: number;
  orderChannel: string;
  orderStatus: string;
  customerChannel: string;
  isLocked: boolean;
}

export interface IFetchOrderActionResponse {
  pagination: number;
  isPaginatedRes: boolean;
  ordersData: Array<IFetchOrderNormalizedResponse>;
}

export interface IFetchOrderDetailResponse {
  orderNumber: number;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy?: any;
  customerId: string;
  customerChannel: string;
  storeName: string;
  phoneNumber: string;
  subTotal: number;
  walletAmount: number;
  discount?: number;
  grandTotal: number;
  shippingAddress: string;
  status: string;
  fulfillmentStatus: string;
  returnStatus?: any;
  orderItems: OrderItem[];
  cnicNumber: string;
  stock?: number;
  zoneId?: string;
  taxBreakDowns: ITaxBreakDownDetails[];
  promos?: IOrderPromoDiscountPayload[];
  expectedDeliveryDate?: string;
  isLocked: boolean;
  deliveryType?: string;
}

export interface ITaxBreakDownDetails {
  amount: number;
  itemId: string;
  taxAmountType: string;
  taxSubType?: string;
  taxId: string;
  type: string;
}

export interface OrderItem {
  stock: any;
  id: string;
  variantId: number;
  itemName: string;
  unitPrice: number;
  quantity: number;
  total: number;
  subTotal: number;
  discount: number;
  additionalDiscount?: number;
  uomSale?: string;
  purchaseTaxId?: string;
  bundleId?: string;
  salesTaxId?: string;
}

export interface IOrderDetailResponseNormalized {
  customerStore: string;
  customerId: string;
  customerNumber: string;
  customerAddress: string;
  customerChannel: string;
  customerNTN: string;
  orderNumber: number;
  createdDate: string;
  createdBy: string;
  updatedDate: string;
  updatedBy?: any;
  status: string;
  fulfillmentStatus: string;
  returnStatus?: any;
  orderDiscount?: number;
  walletAmount?: number;
  orderList: INormalizedOrderItems[];
  zoneId?: string;
  promos?: IOrderPromoDiscountPayload[];
  expectedDeliveryDate?: string | any;
  isLocked: boolean;
  deliveryType?: string;
  partnerChannels?: IPartnerChannel[];
}

export interface INormalizedOrderItems {
  id: string;
  variantId: number;
  itemName: string;
  itemPrice: number;
  quantity: number;
  discount: number;
  stock?: number;
  productOriginalPrice?: number;
  additionalDiscount?: number;
  uomSale?: string;
  purchaseTaxId?: string;
  salesTaxId?: string;
  salesTaxAmount?: number;
  furtherTaxAmount?: number;
  categoryId?: string;
  brandId?: string;
  bundleId?: string;
}

export interface IProductByDisplayOrder {
  id: string;
  title: string;
  imageUrl?: string;
}

export interface ICategoryProductsResponse {
  id: string;
  title: string;
  imageUrl?: string;
}

export interface ISortableList {
  categoryProducts: Array<ICategoryProductsResponse>;
  handleProductSortEnd: (
    productOrder: Array<ICategoryProductsResponse>
  ) => void;
  isCross?: boolean;
  crossHandler?: (index: number) => void;
  distance?: number;
}

export interface ICategoryProductUpdatePayload {
  products: ICategoryProductOrderIdObject;
}

interface ICategoryProductOrderIdObject {
  [key: string]: ICategoryProductOrderObject;
}

interface ICategoryProductOrderObject {
  order: number;
}

export interface ITextField {
  id: string;
  name?: string;
  placeholder: string;
  value?: string | number | undefined;
  type?: any;
  handleChange?: (param: any) => {} | void;
  label?: string;
  error?: any;
  validator?: any;
  isOptional?: boolean;
  onFocus?: any;
  maxLength?: number;
  onKeyPress?: any;
  pattern?: string;
  autoFocus?: boolean;
  onWheel?: any;
  disabled?: boolean;
  className?: string;
}

export interface IAllClientRolesResponse {
  clients: IClientsResponseObject[];
}

export interface IClientsResponseObject {
  id: string;
  name: string;
  roles?: IRolesResponseObject[];
}

export interface IRolesResponseObject {
  id: string;
  title: string;
  clientId: string;
}

export interface IAddUserToRole {
  roleIds: string;
}

export interface IAddUserToClient {
  clientIds: string;
}

export interface ICitiesResponseObject {
  id: string;
  name: string;
}

export interface ISearchableSelect {
  id: string;
  isSearchable: boolean;
  options: any;
  onChange?: (e: any) => void;
  label?: string | null;
  isOptional?: boolean;
  placeholder?: string;
  selectedValue?: any;
  defaultOptions?: Array<IDefaultOptions>;
  isDisabled?: boolean;
}

interface IDefaultOptions {
  id: string;
  value: string;
  text: string;
}

export interface ICheckProductCustomerPayload {
  id: string;
}

export interface ICheckProductProductPayload {
  id: string;
  price: number;
  quantity: number;
  bookedAt?: string;
}

export interface ICheckProductRequestPayload {
  customer: ICheckProductCustomerPayload;
  customerChannel: string;
  partnerChannels: IPartnerChannel[];
  products: ICheckProductProductPayload[];
  zoneInfo?: IZoneInfoState;
}

export interface IFetchProductsForOrderPayload {
  paginationDetails: any;
  zoneInfo?: IZoneInfoState;
  customerChannel: string;
  partnerChannels: IPartnerChannel[];
}

export interface ICheckProductResponsePayload {
  id: string;
  newPrice: number;
  inventoryStatus: string;
  availableInventory?: number;
  availableStock?: any;
}

export interface IAgentManagementUserPageProps extends RouteComponentProps {
  fetchAgentManagementUsers?: (queryParams?: IGetQueryParams) => void;
  createAgentManagementUser: (
    payload: IcreateAgentManagementUserPayload
  ) => void;
  getAgentManagementUserDetailsNew: (id: string) => void | {};
  updateAgentManagementUser: (payload: IcreateUserResponse) => void;
  agentManagementUsers: null | Array<IAgentManagementUsersNormalized>;
  pagination: any;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isAgentManagementUserAdded: boolean;
  isAgentManagementUserUpdated: boolean;
  agentManagementUserDetailsNew: INewAgentManagementUserDetailResponseObject;
}

export interface INewAgentDetailResponseObject {
  accountStatus: string;
  countryCode: string;
  fullName: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
}

export interface INewAgentResponseObject {
  address: IAddress;
  id: string;
  name: string;
  ownerName: string;
  phoneNumber: string;
  status: string;
  storeType: string;
  user: IUser;
}

export interface IAddUpdateAgentPageState {
  [key: string]: any;
}

export interface IAgentManagementPageState {
  [key: string]: any;
}

export interface IAgentManagementUserListProps {
  selectRow?: () => {};
  id?: string;
  store?: string;
  agent?: string;
  contact?: string;
  fetchAgents: (queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedAgent?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  agentManagementUsers: null | Array<IAgentManagementUsersNormalized>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  isAgentManagementUserAddedorUpdated: boolean;
  error: null | string | object;
  isAgentManagementUserAdded: boolean;
  isAgentManagementUserUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
}

export interface ICheckboxProps {
  id: string;
  label: string | JSX.Element;
  isChecked: boolean;
  handleCheckboxChange: (e: any, index?: number) => void;
  disabled?: boolean;
}

export interface IFetchPromoResponse {
  promoId?: string;
  promoCode?: string;
  promoDescription?: string;
  status: string;
  payload: IFetchPromoPayloadRespose;
  discountSlab: any;
}

export interface IFetchPromoPayloadRespose {
  sku: string;
  type: string;
  title: string;
  productId: string;
  variantId: string;
}

export interface IFetchPromoNormalizedResponse {
  id: string;
  promoCode: string;
  promoDescription: string;
  promoStatus: string;
  variantId: string;
  sku: string;
  productTitle: string;
  productId: string;
  basketProducts: IOrderAddUpdateList[];
  minOrderValue: string | number;
  discountValue: string | number;
  isAgreementCheck: boolean;
  channel?: string;
  customerChannels: Array<ISelectDropdownOption>;
}

export interface IFetchPromoActionResponse {
  pagination: number;
  isPaginatedRes: boolean;
  promosData: Array<IFetchPromoNormalizedResponse>;
}

export interface IPromosCityLevelInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPromoAdded: boolean;
  isFetchPromosLoading: boolean;
  isFetchPromosError: boolean;
  promosCityLevel: IFetchPromoNormalizedResponse[];
  pagination: any;
  isPromoUpdated: boolean;
  promoDetails: IVolumetricPromoDetailResponseNormalized | {};
  isPromoDetailsFetched: boolean;
  isPromoByTypeFetched: boolean;
  isPromoByTypeFetchError: boolean;
  typePromo: string;
  promosByType:
    | IPromoBasketDetailResponse[]
    | IPromoDetailResponse[]
    | IDynamicPromoDetailResponse[];
  isWarehouseFetched: boolean;
  warehouseList: IZonesResponseObject[];
  promoId: string;
  promoDescription: string;
  ucList: IZonesResponseObject[];
  isUcFetched: boolean;
  isUserLevelPromoCsvLoading: boolean;
  isUserLevelPromoCsvUploaded: boolean;
  isUserLevelPromoCsvError: boolean;
  userLevelPromoCsvError: null | string | object;
  userLevelPromoCsvFile: any;
  userLevelPromoCsvFileName: string;
}

export interface IPromoCityLevelPageProps extends RouteComponentProps {
  fetchPromos: (queryParams?: IGetQueryParams) => void;
  createPromo: (payload: ICreatePromoPayload) => IPromoDetailResponse;
  uploadUserLevelPromoCsv: (payload: FormData, promoId: string) => void;
  createUploadUserLevelPromoCsv: (
    cityId: string,
    payload: ICreatePromoPayload,
    csvPayload: FormData
  ) => void;
  isUserLevelPromoCsvLoading: boolean;
  isUserLevelPromoCsvUploaded: boolean;
  isUserLevelPromoCsvError: boolean;
  userLevelPromoCsvError: null | string | object;
  userLevelPromoCsvFile: any;
  userLevelPromoCsvFileName: string;
  createBasketPromo: (payload: ICreateBasketPromoPayload) => void;
  createBasketLevel?: (payload: ICreateBasketPromoPayload) => void;
  updatePromoStatus: (id: string) => void;
  updatePromo: (id: string, payload: IUpdatePromoPayload) => void;
  getPromoByType: (type: string) => void;
  getCommandoCategories: (
    isProductDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  promos: Array<IFetchPromoNormalizedResponse>;
  pagination: any;
  isFetchPromosLoading: boolean;
  isFetchPromosError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isPromoAdded: boolean;
  isPromoUpdated: boolean;
  promoDetails:
    | IVolumetricPromoDetailResponseNormalized
    | IBasketPromoDetailResponseNormalized;
  isPromoDetailsFetched: boolean;
  fetchPromoDetails: (id: string) => void;
  clearPromoDetails: () => void;
  isPromoByTypeFetched: boolean;
  isPromoByTypeFetchError: boolean;
  promosByType:
    | IPromoBasketDetailResponse[]
    | IPromoDetailResponse[]
    | IDynamicPromoDetailResponse[];
  typePromo: string;
  commandoProductCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  promosCityLevel?: Array<IFetchPromoNormalizedResponse>;
  getUCByCityId: (selectedCity?: string, queryParams?: IGetQueryParams) => void;
  getWarehouseByCityId: (
    selectedCity?: string,
    queryParams?: IGetQueryParams
  ) => void;
  warehouseList: IZonesResponseObject[] | any;
  promoId: string;
  promoDescription: string;
  isWarehouseFetched: boolean;
  ucList: IZonesResponseObject[] | any;
  isUcFetched: boolean;
  fetchCustomerConfig: () => void;
  customerConfig: ICustomerConfigResponse;
  createUserLevelPromoBulk: (payload: FormData) => void;
  deactivateUserLevelPromoBulk: (payload: FormData) => void;
}

export interface IPromoListProps {
  // fetchPromos: (queryParams?: IGetQueryParams) => void; TODO: Need to remove after successful deployment of citylevel
  fetchPromos: any; // TODO: Need to remove any after successful deployment of citylevel
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedOrder?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  promos: Array<IFetchPromoNormalizedResponse>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPromoAdded: boolean;
  isPromoUpdated: boolean;
  isPromoAddedorUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
}

export interface IPromoCityLevelListProps {
  currentLocation: any;
  fetchPromos: (cityId: string, queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    cityObj: object,
    pageType: IPageType,
    isEdit?: boolean,
    selectedOrder?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  promos: Array<IFetchPromoNormalizedResponse>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPromoAdded: boolean;
  isPromoUpdated: boolean;
  isPromoAddedorUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
  selectedCity?: IIdValuePairResponse | null;
  retainedListPosition?: number;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  promosCityLevel: Array<IFetchPromoNormalizedResponse>;
}

export interface IAddBulkPromosCityLevelPageProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPromoAdded: boolean;
  clearPromoDetails: () => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, currentLocation?: object) => void | {};
  createUserLevelPromoBulk: (payload: FormData, promoType: PromoType) => void;
  selectedCity: IIdValuePairResponse;
}

export interface IDeactivateBulkPromosPageProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPromoUpdated: boolean;
  clearPromoDetails: () => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, currentLocation?: object) => void | {};
  deactivateUserLevelPromoBulk: (payload: FormData) => void;
  selectedCity: IIdValuePairResponse;
}

export interface IAddUpdatePromoCityLevelPageProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPromoAdded: boolean;
  promo: IFetchPromoNormalizedResponse | any;
  //For Volumetric / Dynamic
  createPromo: (
    cityId: string,
    payload: ICreatePromoPayload
  ) => IPromoDetailResponse;
  promoDescription: string;
  isUserLevelPromoCsvUploaded: boolean;
  isUserLevelPromoCsvError: boolean;
  userLevelPromoCsvError: null | string | object;
  userLevelPromoCsvFile: any;
  userLevelPromoCsvFileName: string;
  uploadUserLevelPromoCsv: (payload: FormData, promoId: string) => void;
  createUploadUserLevelPromoCsv: (
    cityId: string,
    payload: ICreatePromoPayload,
    csvPayload: FormData
  ) => void;
  createUserLevelPromoBulk: (payload: FormData) => void;
  createBasketPromo: (payload: ICreateBasketPromoPayload) => void;
  createBasketLevel: (
    cityId: string,
    payload: ICreateBasketPromoPayload
  ) => void;
  updatePromoStatus: (id: string) => void;
  updatePromo: (id: string, payload: IUpdatePromoPayload) => void;
  getPromoByType: (cityId: string, type: string) => void;
  getCommandoCategories: (
    isProductDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, currentLocation?: object) => void | {};
  isPromoUpdated: boolean;
  dummyProductDataProp?: Array<any>;
  dummyIsSearch?: boolean;
  // testingPromoProp?: Array<IOrderAddUpdateList>;
  promoDetails:
    | IVolumetricPromoDetailResponseNormalized
    | IBasketPromoDetailResponseNormalized
    | any;
  isPromoDetailsFetched: boolean;
  fetchPromoDetails: (id: string) => void;
  clearPromoDetails: () => void;
  dummyActualPrice?: string;
  dummyMinUnits?: string;
  dummyDiscount?: string;
  dummyAgreement?: boolean;
  dummyBasketProductsProp?: IOrderAddUpdateList[];
  isPromoByTypeFetched: boolean;
  isPromoByTypeFetchError: boolean;
  promosByType:
    | IPromoBasketDetailResponse[]
    | IPromoDetailResponse[]
    | IDynamicPromoDetailResponse[];
  typePromo: string;
  commandoProductCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  selectedCity: IIdValuePairResponse;
  getWarehouseByCityId: (
    selectedCity?: string,
    queryParams?: IGetQueryParams
  ) => void;
  warehouseList: IZonesResponseObject[] | any;
  promoId: string;
  isWarehouseFetched: boolean;
  getUCByCityId: (selectedCity?: string, queryParams?: IGetQueryParams) => void;
  ucList: IZonesResponseObject[] | any;
  isUcFetched: boolean;
  dynamicPromoCriteriaType: ISelectedBrand | string | any;
  testClients?: IZonesResponseObject[];
  discountPerUnit: any;
  fetchCustomerConfig: () => void;
  customerConfig: ICustomerConfigResponse;
}

export interface IAddUpdateVolumetricPromoState {
  id: string;
  productVariantId: string | number;
  productId: string;
  productSku: string;
  productTitle: string;
  promoStatus: boolean;
  minUnits?: number | string;
  discountPerUnit?: number | string;
  promoDescription: string;
  discountedUnitPrice?: number | string;
  isAgreementCheck?: boolean;
  productActualPrice: number | string;
  slabs: IVolumetricPromoSlabs[];
  channel: string;
  customerChannels: Array<ISelectDropdownOption>;
  selectedCity?: IIdValuePairResponse | any;
}

export interface IAddUpdateDynamicPromoState {
  id: string;
  productVariantId: string | number;
  productId: string;
  productSku: string;
  productTitle: string;
  promoStatus: boolean;
  discountPerUnit?: number | string;
  promoDescription: string;
  discountedUnitPrice?: number | string;
  isAgreementCheck: boolean;
  productActualPrice: number | string;
  channel: string;
  customerChannels: Array<ISelectDropdownOption>;
  selectedCity?: IIdValuePairResponse | any;
  dynamicPromoCriteriaType: string | undefined;
  includedUcs: any;
  includedWarehouses: any;
  isDynamicTypeFetched?: boolean;
}

export interface IAddUpdateUserLevelPromoState {
  id: string;
  productVariantId: string | number;
  productId: string;
  productSku: string;
  productTitle: string;
  promoStatus: boolean;
  discountPerUnit?: number | string;
  promoDescription: string;
  discountedUnitPrice?: number | string;
  isAgreementCheck: boolean;
  productActualPrice: number | string;
  channel: string;
  customerChannels: Array<ISelectDropdownOption>;
  selectedCity?: IIdValuePairResponse | any;
  userLevelCsvFile: any;
  userLevelCsvFileName: string;
  isUserLevelPromoCsvUploaded: boolean;
  isUserLevelPromoCsvError: boolean;
  userLevelPromoCsvError: any;
  promoId: string;
}

export interface IPromoLevelCriteria {
  UC: string;
  Warehouse: string;
}

export interface IAddUpdateBasketPromoState {
  id: string;
  channel: string;
  customerChannels: Array<ISelectDropdownOption>;
  basketProducts: IOrderAddUpdateList[];
  minOrderValue: string | number;
  discountType: string;
  discountValue: string | number;
  isAgreementCheck: boolean;
  promoStatus: boolean;
  promoDescription: string;
  basketCategories: string | INormalizedPromoIncludedCategories;
}

export interface IVolumetricPromoSlabs {
  minUnits: number | string;
  discountPerUnit: number | string;
  discountedUnitPrice: number | string;
  isAgreementCheck: boolean;
  [key: string]: any;
}

export interface IPromoDetailResponse {
  promoId: string;
  promoDescription: string;
  promoCode: string;
  status: string;
  type: string;
  deactivatedAt?: any;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  payload: IPromoMeta | IBasketPromoMeta | IDynamicPromoMeta;
  discountSlab: IPromoDiscountSlabs[] | IBasketPromoDiscountSlabs[];
  channels: string[];
  customerChannels: Array<ISelectDropdownOption> | Array<string>;
}

export interface IDynamicPromoDetailResponse {
  promoId: string;
  promoDescription: string;
  promoCode: string;
  status: string;
  type: string;
  deactivatedAt?: any;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  payload: IPromoMeta | IBasketPromoMeta | IDynamicPromoMeta;
  discountSlab: IPromoDiscountSlabs[] | IBasketPromoDiscountSlabs[];
  channels: string[];
  customerChannels: Array<ISelectDropdownOption>;
}

export interface IPromoIncludedCategories {
  name: string;
  categoryId: string;
}

export interface INormalizedPromoIncludedCategories
  extends IPromoIncludedCategories {
  id?: string;
  value?: string;
  key?: string;
  title?: string;
}

export interface IPromoBasketDetailResponse extends IPromoDetailResponse {
  includedCategories: IPromoIncludedCategories[];
  payload: IBasketPromoMeta;
  discountSlab: IBasketPromoDiscountSlabs[];
}

export interface IPromoDiscountSlabs {
  quantity: string;
  discount: string;
}

export interface IBasketPromoDiscountSlabs {
  amount: string;
  discount: string;
}

export interface IBasketPromoMeta {
  type: string;
  status: string;
  excludedProducts: IExcludedProduct[];
  includedCategories: IPromoIncludedCategories[];
}

export interface IPromoMeta {
  sku: string;
  variantId: string;
  title: string;
  type: string;
  status: string;
  minUnits: string;
  discountPerUnit: number;
  promoDescription: string;
}
export interface IDynamicPromoMeta {
  sku: string;
  variantId: string;
  title: string;
  type: string;
  status: string;
  includedUcs: [];
  includedWarehouses: [];
  discountPerUnit: number;
  promoDescription: string;
}

export interface IVolumetricPromoDetailResponseNormalized {
  id: string;
  promoCode: string;
  promoDescription: string;
  promoStatus: string;
  type: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  slabs: IVolumetricPromoDiscountSlabs[];
  promoMeta: IPromoMetaNormalized;
  channel: string;
  customerChannels: Array<ISelectDropdownOption>;
}
export interface IDynamicPromoDetailResponseNormalized {
  id: string;
  promoCode: string;
  promoDescription: string;
  promoStatus: string;
  type: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  promoMeta: IPromoMetaNormalized;
  channel: string;
  customerChannels: Array<ISelectDropdownOption>;
}

export interface IUserLevelPromoDetailResponseNormalized {
  id: string;
  promoCode: string;
  promoStatus: string;
  type: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  promoMeta: IPromoMetaNormalized;
  channel: string;
}

export interface IBasketPromoDetailResponseNormalized {
  id: string;
  promoCode: string;
  promoDescription: string;
  promoStatus: string;
  type: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  minOrderValue: number;
  discountValue: number;
  basketProducts: IOrderAddUpdateList[];
  basketCategories: INormalizedPromoIncludedCategories[];
  channel: string;
  customerChannels: Array<ISelectDropdownOption>;
}

export interface IVolumetricPromoDiscountSlabs {
  minimumUnits: number;
  discount: number;
}

export interface IPromoMetaNormalized {
  sku: string;
  variantId: string;
  productTitle: string;
  type: string;
  status: string;
}

export interface ICreatePromoPayload {
  root: IRoot;
  meta: IMeta[] | IBasketMeta[];
  promoType: string;
  promoDescription: string | undefined;
  requestBody:
    | IVolumetricPromoCreateRequestBody
    | IBasketPromoCreateRequestBody
    | IDynamicPromoCreateRequestBody;
  promoChannels?: string[] | any;
  customerChannels?: string[] | any;
}

export interface IDynamicPromoCreateRequestBody {
  sku: string;
  type: string;
  title: string;
  status: string | undefined;
  variantId: string;
  productId: string;
  includedUcs: IZonesResponseObject[];
  includedWarehouses: IWarehousePayload[];
}
export interface ICreateBasketPromoPayload extends ICreatePromoPayload {
  meta: IBasketMeta[];
  requestBody: IBasketPromoCreateRequestBody;
}

export interface IRoot {
  conditions: ICondition[];
}

export interface IMeta {
  amount?: string;
  quantity?: string;
  discount?: string;
}

export interface IBasketMeta {
  amount: string;
  discount: string;
}

export interface IBasketPromoCreateRequestBody {
  type: string;
  status: string | undefined;
  excludedProducts: IExcludedProduct[];
  includedCategories: IPromoIncludedCategories[];
}

export interface IExcludedProduct {
  sku: string;
  title: string;
  productId: string;
  variantId: string;
}

export interface IVolumetricPromoCreateRequestBody {
  sku: string;
  type: string;
  title: string | undefined;
  status: string;
  variantId: string;
  productId: string;
}

export interface ICondition {
  any: IAny[];
  event: IEvent;
}

export interface IAny {
  all: IAll[];
}

export interface IEvent {
  field: string;
  value: number;
  valueType: string;
}

export interface IAll {
  field: string;
  operator: string;
  value: string;
  valueType: string;
}

export interface IAllDynamicUserLevel {
  field: string;
  operator: string;
  // value: string;
  valueType: string;
}
export interface IValidationObject {
  isValidated: boolean;
  errorMessage: string[];
}

export interface IPromoProductSearchNormalized {
  id: string;
  variantId: string;
  itemName: string;
  productOriginalPrice: number;
  itemAvailable: string;
  stock: number;
  isFlatDiscount: boolean;
  isVolumetricDiscount: boolean;
  categoryStatus?: boolean;
  isChecked?: boolean;
  productSku: string;
}

export interface IUpdatePromoStatusPayload {
  status: string;
}

export interface ITabs {
  tabsData: ITabsData[];
}

export interface ITabsData {
  id: string;
  tabLink: string;
  content: any;
}

export interface IWarehousePayload extends IIdValuePairResponse {
  id: string;
  name: string;
  latitude: number;
  longitude: number;
}

export interface IDeliveryOption {
  id: string;
  key: string;
  title: string;
  label: string;
}

export interface INormalizedProductInventory {
  warehouseId: string;
  quantity: number;
  primeQuantity: number;
}

export interface IProductInventoryPayload {
  productId: string | number;
  inventoryDetails: any;
}

export interface IProductInventory {
  warehouseId: string;
  quantity: number;
  primeQuantity: number;
}

export interface IChipProps {
  id?: string;
  chipName: string;
  clickHandler?: (e: any) => void;
  isDisable?: boolean;
  isCross?: boolean;
  crossHandler?: (index: any) => void;
}

export interface IAgentManagementPageProps extends RouteComponentProps {
  getAgentList: (queryParams?: IGetQueryParams) => void;
  getUpdateAgentDetail: (id: string) => void | {};
  getAllAgentZones: (
    selectedCity?: string,
    customerChannel?: string,
    queryParams?: IGetQueryParams
  ) => void;
  createAgentWithTypeTeamZones: (payload: ICreateAgentOnlyReq) => void;
  createAgentUserWithTypeTeamZones: (
    payload: ICreateUpdateAgentManagementUserNormalizedReq
  ) => void;
  updateAgentUserWithTypeTeamZones: (
    payload: ICreateUpdateAgentManagementUserNormalizedReq
  ) => void;
  agentManagementUsers: null | Array<IAgentManagementUsersNormalized>;
  pagination: any;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isAgentManagementUserAdded: boolean;
  isAgentManagementUserUpdated: boolean;
  agentManagementUserDetails: INewAgentManagementUserDetailResponseObject;
  allAgentZones: IZonesResponseObject[] | null;
  isAllAgentZonesFetched: boolean;
  userInfo: ILoginUserInfo;
  fetchAgentTitle: () => void;
  agentTitle: ISelectedBrand[];
  fetchAgentTeam: () => void;
  agentTeam: ISelectedBrand[];
  fetchBrands: () => void;
  brands: ISelectedBrand[];
  fetchCustomerConfig: () => void;
  customerConfig: ICustomerConfigResponse;
  getBulkCustomerDetailsByIdAction: (ids: string[]) => void | {};
  clearBulkCustomerDetailsAction: () => void | {};
  bulkCustomerDetails: Record<string, IGetCustomerNewDetailResponse>;
  isBulkCustomerDetailsFetched: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
}

export interface IcreateAgentManagementUserPayload {
  id: string;
  name: string;
  phoneNumber: string;
  nationalId: string;
  password: string;
  confirmPassword: string;
}

export interface IAgentManagementInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isAgentManagementUserAdded: boolean;
  agentManagementUsers: null | Array<IAgentManagementUsersNormalized>;
  pagination: any;
  agentManagementUserDetails: INewAgentManagementUserDetailResponseObject | null;
  isagentManagementUserDetailsFetched: boolean;
  isAgentManagementUserUpdated: boolean;
  allZones: null | IAgentsResponseObject[];
  isAllZonesFetched: boolean;
  agentTitle: ISelectedBrand[];
  agentTeam: ISelectedBrand[];
  brands: ISelectedBrand[];
}

export interface INewAgentManagementUserDetailResponseObject {
  accountStatus: string;
  countryCode: string;
  name: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
  title: string | ISelectedBrand;
  team: string | ISelectedBrand;
  zoneIds: Array<string>;
}

export interface ICreateUpdateAgentManagementUserNormalizedReq {
  id?: string;
  agentName: string;
  accountStatus?: string;
  countryCode?: string;
  nationalId: string;
  email?: string;
  phoneNumber: string;
  password?: string;
  confirmPassword?: string;
  title: string | ISelectedBrand;
  teamId: string | ISelectedBrand;
  customerChannel: string;
  zones: Array<any>;
  brands: Array<ISelectedBrand>;
  status?: string | boolean;
  userId?: string;
  agentId?: string;
}

export interface ICreateAgentOnlyReq {
  userId: string;
  title: string | ISelectedBrand;
  teamId?: string | ISelectedBrand;
  customerChannel: string;
  agentName: string;
  phoneNumber: string;
  status?: string | boolean;
  zones: Array<any>;
  brands: Array<ISelectedBrand>;
}

export interface IAddUpdateAgentManagementPageState {
  accountStatus?: string;
  countryCode?: string;
  agentName: string;
  agentId: string;
  userId: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
  email?: string | any;
  password: string;
  confirmPassword: string;
  title: ISelectedBrand | string;
  team: ISelectedBrand | string | any;
  customerChannel?: ISelectDropdownOption;
  teamId?: ISelectedBrand | string | any;
  zones: Array<IZonesResponseObject>;
  brands: Array<ISelectedBrand>;
  status: string | boolean;
  resetPasswordModal: boolean | any;
  isAgentDetailsFound: boolean;
  createdByUser: string;
  createdAt: string;
  updatedByUser: string;
  updatedAt: string;
}

export interface INewAgentManagementUserResponseObject {
  zones: Array<IAgentsResponseObject>;
  user: IAgentManagementUserResponseObject;
}

export interface IAgentManagementUsersNormalized {
  agentId: string;
  userId: string;
  name: string;
  phoneNumber: string | undefined;
  cnicNumber: string;
  status: string | undefined;
  countryCode: string;
  teamId: ISelectedBrand | string;
  titleId: ISelectedBrand | string;
  title: ISelectedBrand | string;
  zones: Array<IAgentsResponseObject>;
  brands: Array<ISelectedBrand>;
  agentTitleName: string;
  agentTeamName: string;
  customerChannel: string;
  email: string;
  createdByUser: string;
  createdAt: string;
  updatedByUser: string;
  updatedAt: string;
}

export interface IAllAgentRolesResponse {
  id: string;
  name: string;
}

export interface IAgentsResponseObject {
  id: string;
  name: string;
}

export interface IZonalConfigChildZonesResponse {
  id: string;
  name: string;
}

export interface IAgentManagementListProps {
  selectRow?: () => {};
  id?: string;
  store?: string;
  agentManagementUser?: string;
  contact?: string;
  getAgentList: (queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedAgentManagementUser?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  agentManagementUsers: null | Array<IAgentManagementUsersNormalized>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  isAgentManagementUserAddedorUpdated: boolean;
  error: null | string | object;
  isAgentManagementUserAdded: boolean;
  isAgentManagementUserUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
  userInfo: ILoginUserInfo;
  testAgentManagementUserStateData?: any;
  passwordReset: any;
}

export interface IAddUpdateAgentManagementPageProps
  extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  handleDeactivateAccount?: () => void;
  isAgentManagementUserAdded: boolean;
  selectedAgentManagementUser: IAgentManagementUserResponseObject;
  getAllAgentZones: (
    selectedCity?: string,
    customerChannel?: string,
    queryParams?: IGetQueryParams
  ) => void;
  createAgentTeamZone: (payload: ICreateAgentOnlyReq) => void;
  createAgentTitleTeamZone: (
    payload: ICreateUpdateAgentManagementUserNormalizedReq
  ) => void;
  updateAgentTitleTeamZone: (
    payload: ICreateUpdateAgentManagementUserNormalizedReq
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, passwordReset?: any) => void | {};
  handleSearchableSelect?: (e: any, id: string) => void | {};
  isagentManagementUserDetailsFetched?: boolean;
  agentManagementUserDetails: INewAgentManagementUserDetailResponseObject;
  getUpdateAgentDetail: (id: string) => void | {};
  isAgentManagementUserUpdated?: boolean;
  allAgentZones: IZonesResponseObject[] | null;
  isAllAgentZonesFetched: boolean;
  userInfo: ILoginUserInfo;
  testClients?: IZonesResponseObject[];
  testClientRoles?: IRolesResponseObject[];
  fetchAgentTitle: () => void;
  agentTitle: any[];
  fetchAgentTeam: () => void;
  agentTeam: any[];
  fetchBrands: () => void;
  brands: any[];
  customerConfig: ICustomerConfigResponse;
  fetchCustomerConfig: () => void;
  getBulkCustomerDetailsByIdAction: (ids: string[]) => void | {};
  clearBulkCustomerDetailsAction: () => void | {};
  bulkCustomerDetails: Record<string, IGetCustomerNewDetailResponse>;
  isBulkCustomerDetailsFetched: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  selectedCity?: string | IIdValuePairResponse;
  searchText?: string | number;
}

export interface IAgentManagementUserResponseObject {
  id: string;
  accountStatus: string;
  countryCode: string;
  agentName: string;
  name: string;
  agentId: string;
  userId: string;
  email: string;
  nationalId: string;
  phoneNumber: string;
  password: string;
  confirmPassword: string;
  title: ISelectedBrand | string;
  team: ISelectedBrand | string;
  customerChannel: ISelectDropdownOption;
  zones: Array<IZonesResponseObject>;
  status: string | boolean;
  teamId?: ISelectedBrand | string;
  titleId?: ISelectedBrand | string;
  brands: Array<ISelectedBrand>;
  createdByUser: string;
  createdAt: string;
  updatedByUser: string;
  updatedAt: string;
}

export interface IZonesResponseObject {
  zoneId?: string;
  id: string;
  name: string;
}

export interface IBrandsResponseObject {
  brandId?: string;
  id: string;
  name: string;
}

export interface IAgentTitle {
  id: string;
  title: string;
  value?: string;
  key?: string;
  label?: string;
}

export interface ICustomerConfigResponse {
  customerChannels: ISelectDropdownOption[];
}

export interface IAllZonesResponse {
  allZones: IZonesResponseObject[];
}

export interface IOdooTaxResponse {
  id: string;
  name: string;
  taxType: string;
  amountType: string;
  amount: number;
  status: boolean;
  description: string;
}

export interface IOdooTaxListResponse extends IOdooTaxResponse {
  value: string;
  title: string;
  key: string;
  label?: string;
}

export interface IOdooTaxState {
  sellingTax: IOdooTaxListResponse[];
  purchaseTax: IOdooTaxListResponse[];
}

export interface ITourAssignmentPageProps {
  isEdit: boolean;
  isLoading: boolean;
  isError: boolean;
  isTourAssigned: boolean;
  error: null | string | object;
  isCsvUploaded: boolean;
  dummyTour?: string;
  dummyRider?: string;
  assignTour: (payload: IAssignTourPayload) => void;
  reassignTour: (payload: IReassignTourPayload) => void;
  uploadTourCsv: (payload: FormData, url: string) => void;
}

export interface ITourReassignmentModalProps {
  texts: string[];
  open: boolean;
  tourNumber: string;
  riderId: string;
  reassignTour: (payload: IReassignTourPayload) => void;
  closeHandler: (status: boolean) => void;
}

export interface ITourPageState {
  tourSearchSelect: string;
  riderSearchSelect: string;
}

export interface IReassignTourPayload {
  riderId: string;
  tourNumber: string;
}

export interface IAssignTourPayload {
  tourNumber: string;
  ridersPhone: string;
}

export interface IShipperInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isTourAssigned: boolean;
  isPlanAssigned: boolean;
  isCsvUploaded: boolean;
}

export interface IZoneInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCityListFetched: boolean;
  citiesList: IIdValuePairResponse[];
  retainedCity: IIdValuePairResponse | null;
}

export interface IPlanAssignmentPageState {
  plans: string;
}

export interface IPlanAssignmentPageProps {
  isEdit: boolean;
  isLoading: boolean;
  isError: boolean;
  isPlanAssigned: boolean;
  error: null | string | object;
  assignPlan: (payload: string[]) => void;
  dummyPlans?: string;
}

export interface IPlanAssignmentPageState {
  plans: string;
}

export interface IActivePromosForOrderPayload {
  BASKET: IPromoDetailResponse[];
  VOLUMETRIC: IPromoDetailResponse[];
  DYNAMIC: IDynamicPromoDetailResponse[];
}

export interface IIdValuePairResponse {
  status?: any;
  id: string;
  name: string;
  value?: string;
  title?: string;
  label?: string;
}
export interface IOrderDiscountObject {
  show: boolean;
  value: number;
  isBasketDiscount: boolean;
  promoId: string;
  promoType: string;
}

export interface IProductCityLevelPayload {
  id?: string;
  productCityLevelSku: string;
  productCityLevelTitle: string;
  productCityLevelDescription: string;
  productCityLevelCategories: string;
  variantId?: string;
  productCityLevelOriginalPrice: string;
  productCityLevelDisplayPrice: string;
  productCityLevelRetailPrice: string;
  status: string | boolean;
  productCityLevelImage: string;
  brand?: ISelectedBrand | string;
  appChannels?: any; // Will define the type of the channel later.
  sellingTax: string | ISelectedBrand;
  purchaseTax: string | ISelectedBrand;
  selectedCity: any;
  uomSale: string;
  customerChannelAttributesMap: ICustomerChannelAttributesMap | Object;
  advanceTaxApplicable: string | boolean;
  furtherTaxApplicable: string | boolean;
  storageBlock: IStorageBlock;
}

export interface IProductCityLevelPageProps extends RouteComponentProps {
  fetchProductCityLevels: (
    cityId: string,
    queryParams?: IGetQueryParams
  ) => void;
  fetchProductCityLevelTypes: () => void;
  fetchProductCityLevelUom: () => void;
  bulkUploadProductCityLevel: (payload: FormData, url: string) => void;
  inventoryUploadProductCityLevel: (payload: FormData, url: string) => void;
  bulkUploadNewCityLevelProductPrice: (payload: FormData, url: string) => void;
  clearProductCityLevelDetails: () => void;
  getCommandoCategories: (
    isProductCityLevelDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  productsCityLevel: Array<IProductCityLevelPayload>;
  pagination: any;
  isFetchProductCityLevelLoading: boolean;
  isFetchProductCityLevelError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isProductCityLevelAdded: boolean;
  isProductCityLevelUpdated: boolean;
  isProductCityLevelBulkUploaded: boolean;
  isProductCityLevelBulkUploading: boolean;
  isProductCityLevelBulkUploadingError: boolean;
  isProductCityLevelInventoryUploaded: boolean;
  isProductCityLevelInventoryUploading: boolean;
  isProductCityLevelInventoryUploadingError: boolean;
  isNewCityLevelProductPricesUploading: boolean;
  isNewCityLevelProductPricesUploadingError: boolean;
  isNewCityLevelProductPricesUploaded: boolean;
  productCityLevelDetails: IProductCityLevelPayload;
  isProductCityLevelDetailsFetched: boolean;
  commandoProductCityLevelCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  productCityLevelTypes: Array<any>;
  productCityLevelUomList: Array<any>;
  fetchProductCityLevelBrands: () => void;
  productCityLevelBrands: Array<any>;
  productCityLevelFetchWareHouseNames: (queryParam: any) => void;
  wareHouseNames: Array<IWarehousePayload>;
  fetchProductCityLevelInventory: (id: string, queryParam: any) => void;
  productCityLevelInventory: IProductInventory[];
  updateProductCityLevelInventory: (id: string, payload: FormData) => void;
  isProductCityLevelInventoryUpdated: boolean;
  isProductCityLevelInventoryFetched: boolean;
  odooTax: null | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  productCityLevelFetchTaxFromOdoo: (id?: string) => void;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  selectedCity: string;
  roles: string[];
}

export interface IProductCityLevelListProps {
  fetchProductCityLevels: (
    cityId: string,
    queryParams?: IGetQueryParams
  ) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedProductCityLevel?: any,
    searchText?: any,
    selectedCity?: object,
    currentScroll?: any
  ) => void;
  uploadBulkProductCityLevel: (payload: FormData, url: string) => void;
  uploadInventoryProductCityLevel: (payload: FormData, url: string) => void;
  bulkUploadNewCityLevelProductPrice: (payload: FormData, url: string) => void;
  productsCityLevel: Array<IProductCityLevelPayload>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  isProductCityLevelAddedorUpdated: boolean;
  currentLocation: any;
  error: null | string | object;
  isProductCityLevelBulkUploaded: boolean;
  isProductCityLevelBulkUploading: boolean;
  isProductCityLevelBulkUploadingError: boolean;
  isProductCityLevelInventoryUploaded: boolean;
  isProductCityLevelInventoryUploading: boolean;
  isProductCityLevelInventoryUploadingError: boolean;
  isNewCityLevelProductPricesUploading: boolean;
  isNewCityLevelProductPricesUploadingError: boolean;
  isNewCityLevelProductPricesUploaded: boolean;
  isProductCityLevelAdded: boolean;
  isProductCityLevelUpdated: boolean;
  retainedSearchText: string;
  currentListPosition: number;
  testIsSearchProp?: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  selectedCity: string;
  roles: string[];
}

export interface IAddUpdateProductCityLevelProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isProductCityLevelAdded: boolean;
  productCityLevel: IProductCityLevelPayload;
  clearProductCityLevelDetails: () => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, currentLocation?: any) => void | {};
  isProductCityLevelUpdated: boolean;
  productCityLevelDetails: IProductCityLevelPayload;
  isProductCityLevelDetailsFetched: boolean;
  getCommandoCategories: (
    isProductCityLevelDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  commandoProductCityLevelCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  commandoCategoryError: null | string | object;
  productCityLevelTypes: Array<any>;
  productCityLevelUomList: Array<any>;
  fetchProductCityLevelBrands: () => void;
  productCityLevelBrands: Array<any>;
  dummyValidations?: boolean;
  productCityLevelFetchWareHouseNames: (queryParam: any) => void;
  wareHouseNames: Array<IWarehousePayload>;
  fetchProductCityLevelInventory: (id: string, queryParam: any) => void;
  productCityLevelInventory: IProductCityLevelInventory[];
  updateProductCityLevelInventory: (id: string, payload: any) => void;
  isProductCityLevelInventoryFetched: boolean;
  odooTax: null | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  productCityLevelFetchTaxFromOdoo: (id?: string) => void;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  selectedCity: any;
  roles: string[];
}

export interface IProductCityLevelInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isProductCityLevelAdded: boolean;
  isFetchProductCityLevelLoading: boolean;
  isFetchProductCityLevelError: boolean;
  productsCityLevel: Array<any>;
  pagination: any;
  isProductCityLevelUpdated: boolean;
  isProductCityLevelBulkUploaded: boolean;
  isProductCityLevelBulkUploading: boolean;
  isProductCityLevelBulkUploadingError: boolean;
  isProductCityLevelInventoryUploaded: boolean;
  isProductCityLevelInventoryUploading: boolean;
  isProductCityLevelInventoryUploadingError: boolean;
  isNewCityLevelProductPricesUploaded: boolean;
  isNewCityLevelProductPricesUploading: boolean;
  isNewCityLevelProductPricesUploadingError: boolean;
  productCityLevelBrands: Array<any>;
  wareHouseNames: Array<IWarehousePayload>;
  productCityLevelInventory: null | IProductInventoryPayload;
  isProductCityLevelInventoryUpdated: boolean;
  isProductCityLevelInventoryFetched: boolean;
  odooTax: null | IOdooTaxResponse | IOdooTaxListResponse[];
  isOdooTaxFetched: boolean;
  productCityLevelDetails: IProductPayload | {};
  isProductCityLevelDetailsFetched: boolean;
  citiesList: IIdValuePairResponse[];
  deliveryOptions: IDeliveryOption[];
}

export interface IProductCityLevelDetailsResponse {
  id: number;
  title: string;
  description: string;
  status: string;
  variantId: number;
  sku: string;
  originalPrice: string;
  displayPrice: string;
  retailPrice: number;
  inventory: IInventory;
  imageId: string;
  imageUrl: string;
  brand: any;
  customerApp: string | boolean;
  agentApp: string | boolean;
  adminCommando: string | boolean;
  appChannels: any;
  tax: IProductDetailTaxPayload;
  selectedCity: any;
  category: string;
  uomSale: string;
  customerChannelAttributesMap: ICustomerChannelAttributesMap | string;
  storageBlock: string;
}

export interface IPromoProductCityLevelSearchNormalized {
  id: string;
  variantId: string;
  itemName: string;
  productOriginalPrice: number;
  itemAvailable: string;
  stock: number;
  isFlatDiscount: boolean;
  isVolumetricDiscount: boolean;
  categoryStatus?: boolean;
  isChecked?: boolean;
  productSku: string;
}

export interface INormalizedProductCityLevelInventory {
  warehouseId: string;
  quantity: number;
  primeQuantity: number;
}

export interface IProductCityLevelInventory {
  warehouseId: string;
  quantity: number;
  primeQuantity: number;
}

export interface IProductCityLevelInventoryPayload {
  productCityLevelId: string;
  inventoryDetails: any;
}

export interface IIdsPayload {
  ids: string[];
}

export interface ICategoryGlobalListingResponseAction {
  pagination: number | number;
  isPaginatedRes: boolean;
  categoriesData: Array<ICategoryListingNormalizedData>;
}

export interface ICategoryGlobalListingResponse {
  id: string;
  title: string;
  description: string;
  enabled: boolean;
  categoryType: string;
  imageUrl?: string;
  imageId?: string;
  handle?: string;
  cities: Array<ICitiesResponseObject>;
}

export interface ICategoryGlobalListingNormalizedData {
  id: string;
  categoryTitle: string;
  categoryType: string;
  parentId: string | null;
  cities?: string;
  title?: string;
  key?: string;
  handle?: string;
}

export interface ICategoryGlobalInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCategoryGlobalAdded: boolean;
  isFetchCategoryGlobalLoading: boolean;
  isFetchCategoryGlobalError: boolean;
  categoriesGlobal: null | Array<any>;
  pagination: any;
  coreCategories: Array<any>;
  isCoreCategoriesFetched: boolean;
  isCategoryGlobalUpdated: boolean;
}

export interface ICategoryGlobalInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
}

export interface ICategoryGlobalProductsResponse {
  id: string;
  title: string;
  imageUrl?: string;
}

export interface ICategoryGlobalListProps {
  fetchCategoriesGlobal: (
    isProductDetailPage: boolean,
    queryParams?: IGetQueryParams
  ) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedCategory?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  categoriesGlobal: Array<ICategoryGlobalListingNormalizedData[]>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCategoryGlobalAdded: boolean;
  isCategoryGlobalUpdated: boolean;
  isCategoryGlobalAddedorUpdated: boolean;
  testIsSearchProp?: boolean;
  currentListPosition: number;
  retainedSearchText: string;
}

export interface ICategoryCityLevelPageProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  pagination: any;
  isCategoryUpdated: boolean;
  fetchCities: () => void;
  cityList: IIdValuePairResponse[];
  fetchCategories: (cityId: string, queryParam: IGetQueryParams) => void;
  categoryList: ICategoryListingNormalizedData[][];
  fetchCategoryProducts: (categoryId: string, cityId: string) => void;
  categoryProductList: Array<ICategoryProductsResponse>;
  reorderCategoryProducts: (
    categoryId: string,
    cityId: string,
    payload: ICategoryProductUpdatePayload
  ) => void;
  updateCategory: (
    categoryId: string,
    cityId: string,
    payload: ICategoryCityLevelPayload
  ) => void;
}

export interface ICategoryCityLevelListProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCategoryUpdated: boolean;
  retainedListPosition: number;
  retainedSearchText: string;
  retainedSelectedCity: IIdValuePairResponse | null;
  pagination: any;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  fetchCategories: (cityId: string, queryParam: IGetQueryParams) => void;
  categoryList: ICategoryListingNormalizedData[][];
  updatePageHandler: (
    searchText: string,
    currentScroll: number,
    selectedCity: IIdValuePairResponse | null,
    selectedCategory: ICategoryListingNormalizedData,
    selectedCategoryParent?: ICategoryListingNormalizedData
  ) => void;
}

export interface ICategoryPageProps extends RouteComponentProps {
  fetchCategoriesGlobal: (
    isProductDetailPage: boolean,
    queryParams?: IGetQueryParams
  ) => void;
  createCategoryGlobal: (payload: any) => void;
  getCoreCategoriesGlobal: () => void | {};
  uploadCategoryGlobalImage: (payload: FormData) => Promise<any>;
  uploadCategoryImageAndCreateCategory: (
    imgPayload: FormData,
    fieldPayload: ICreateCategoryPayload,
    isEdit: boolean
  ) => void;
  updateCategoryGlobal: (id: string, payload: ICreateCategoryPayload) => void;
  categoriesGlobal: Array<ICategoryListingNormalizedData[]>;
  pagination: any;
  isFetchCategoryGlobalLoading: boolean;
  isFetchCategoryGlobalError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isCategoryGlobalAdded: boolean;
  isCategoryGlobalUpdated: boolean;
  coreCategoriesGlobal: Array<any>;
  isCoreCategoriesGlobalFetched: boolean;
  isCategoryGlobalImageUploading: boolean;
  isCategoryGlobalImageUploaded: boolean;
  SortableList: IProductByDisplayOrder;
  isCategoryGlobalProductsFetched: boolean;
  isCategoryGlobalProductsError: boolean;
  categoryGlobalProducts: Array<ICategoryProductsResponse>;
  fetchCategoryGlobalProduct: (id: string) => void;
  updateCategoryGlobalProduct: (
    id: string,
    payload: ICategoryGlobalProductUpdatePayload
  ) => void;
  isCategoryGlobalProductsUpdated: boolean;
  // isProductBulkUploadingError: boolean;
}

export interface ICategoryGlobalProductUpdatePayload {
  products: ICategoryGlobalProductOrderIdObject;
}

interface ICategoryGlobalProductOrderIdObject {
  [key: string]: ICategoryGlobalProductOrderObject;
}

interface ICategoryGlobalProductOrderObject {
  order: number;
}

export interface ICategoryGlobalPageProps extends RouteComponentProps {
  fetchCategoriesGlobal: (
    isProductDetailPage: boolean,
    queryParams?: IGetQueryParams
  ) => void;
  createCategoryGlobal: (payload: any) => void;
  getCoreCategoriesGlobal: () => void | {};
  uploadCategoryGlobalImage: (payload: FormData) => Promise<any>;
  uploadCategoryGlobalImageAndCreateCategoryGlobal: (
    imgPayload: FormData,
    fieldPayload: ICreateCategoryGlobalPayload,
    isEdit: boolean
  ) => void;
  updateCategoryGlobal: (
    id: string,
    payload: ICreateCategoryGlobalPayload
  ) => void;
  categoriesGlobal: Array<ICategoryGlobalListingNormalizedData[]>;
  isCategoryGlobalAddedorUpdated: boolean;
  pagination: any;
  isFetchCategoryGlobalLoading: boolean;
  isFetchCategoryGlobalError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isCategoryGlobalAdded: boolean;
  isCategoryGlobalUpdated: boolean;
  coreCategories: Array<any>;
  isCoreCategoriesGlobalFetched: boolean;
  isCategoryGlobalImageUploading: boolean;
  isCategoryGlobalImageUploaded: boolean;
  SortableList: IProductByDisplayOrder;
  isCategoryGlobalProductsFetched: boolean;
  isCategoryGlobalProductsError: boolean;
  categoryProducts: Array<ICategoryGlobalProductsResponse>;
  fetchCategoryGlobalProduct: (id: string) => void;
  updateCategoryGlobalProduct: (
    id: string,
    payload: ICategoryGlobalProductUpdatePayload
  ) => void;
  isCategoryGlobalProductsUpdated: boolean;
  cities: Array<ICitiesResponseObject>;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
}

export interface ICreateCategoryGlobalPayload {
  id?: string;
  name: string;
  description: string;
  type: string;
  coreCategory?: ICoreCategoryGlobal;
  enabled: number;
  imageId?: string;
  imageUrl?: string;
}

export interface ICreateCategoryGlobalPayload {
  id?: string;
  name: string;
  description: string;
  type: string;
  coreCategory?: ICoreCategoryGlobal;
  enabled: number;
  imageId?: string;
  imageUrl?: string;
}

export interface IUpdateCategoryCityLevelProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCategoryUpdated: boolean;
  city: IIdValuePairResponse;
  category: ICategoryListingNormalizedData;
  categoryParent?: ICategoryListingNormalizedData;
  backButtonHandler: (retainState?: boolean) => void;
  fetchCategoryProducts: (categoryId: string, cityId: string) => void;
  categoryProductList: Array<ICategoryProductsResponse>;
  reorderCategoryProducts: (
    categoryId: string,
    cityId: string,
    payload: ICategoryProductUpdatePayload
  ) => void;
  updateCategory: (
    categoryId: string,
    cityId: string,
    payload: ICategoryCityLevelPayload
  ) => void;
}

export interface IAddUpdateCategoryGlobalProps extends RouteComponentProps {
  dummyValidation: boolean;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCategoryGlobalAdded: boolean;
  selectedCategoryGlobal: ICategoryGlobalPayload;
  fetchCategoriesGlobal: (
    isProductDetailPage: boolean,
    queryParams?: IGetQueryParams
  ) => void;
  categoriesGlobal: Array<ICategoryGlobalListingNormalizedData[]>;
  isCategoryGlobalAddedorUpdated: boolean;
  createCategoryGlobal: (payload: any) => void;
  updateCategoryGlobal: (
    id: string,
    payload: ICreateCategoryGlobalPayload
  ) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any) => void | {};
  isCategoryGlobalUpdated?: boolean;
  getCoreCategoriesGlobal: () => void | {};
  coreCategories: Array<any>;
  isCoreCategoriesGlobalFetched: boolean;
  // cities: Array<ICitiesResponseObject>;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
}

export interface IAddUpdateZonalConfigProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isZonalConfigAdded: boolean;
  zonalConfigs: IZonalConfigPayload;
  createZonalConfig: (payload: any) => void;
  updateZonalConfig: (
    id: string,
    zoneType: string,
    payload: IZonalConfigPayload
  ) => void;
  getZonalConfigDetails: (id: string, cityId: string) => void;
  clearZonalConfigDetails: () => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, currentLocation?: any) => void | {};
  isZonalConfigUpdated: boolean;
  zonalConfigDetails: IZonalConfigPayload;
  isZonalConfigDetailsFetched: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  selectedCity: any;
  getWarehouseCategories: (queryParams?: IGetQueryParams) => void | {};
  warehouseCategories: Array<IWarehouseCategory>;
  isWarehouseCategoriesFetched: boolean;
  getZonalConfigChildZones: (id: string) => void | {};
  zonalConfigChildZones: Array<IWarehouseCategory>;
  isZonalConfigChildZonesFetched: boolean;
  getZonalConfigTowns: (id: string) => void | {};
  zonalConfigTowns: Array<IWarehouseCategory>;
  isZonalConfigTownsFetched: boolean;
  getZonalConfigWarehouse: (
    id: string,
    zoneType: string,
    zoneStatus: boolean
  ) => void | {};
  isZonalConfigWarehouseNameFetched: boolean;
  zonalConfigWarehouseName: object;
  getBulkCustomerDetailsByIdAction: (ids: string[]) => void | {};
  clearBulkCustomerDetailsAction: () => void | {};
  bulkCustomerDetails: Record<string, IGetCustomerNewDetailResponse>;
  isBulkCustomerDetailsFetched: boolean;
  getZonalConfigWarehouseListWithStorageBlocks: (
    id: string,
    zoneType: string
  ) => void | {};
  isZonalConfigWarehouseListWithStorageBlocksFetched: boolean;
  zonalConfigWarehouseListWithStorageBlocks: IWarehouseStorageBlock[];
  customerConfig: ICustomerConfigResponse;
  fetchCustomerConfig: () => void;
  getZoneCustomerChannelConfig: (cityId: string) => void;
  zonalConfigChannelName: string | null;
  isFetchCustomerChannelLoading: boolean;
}

export interface IZonalConfigPayload {
  id: string;
  type: ISelectedBrand | string | any;
  zoneName: string;
  town: ISelectedBrand | string | any;
  zone: ISelectedBrand | string | any;
  selectedCity: any;
  status: any;
  warehouse: ISelectedBrand | string | any;
  selectedWarehouseListWithStorageBlocks: IWarehouseStorageBlock[];
  locationPolygonText: string;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
  customerChannel?: ISelectDropdownOption;
}

export interface ICategoryGlobalPayload {
  id?: ISelectedBrand | string;
  categoryType: string;
  categoryFeature: string;
  categoryTitle: string;
  coreCategory: ISelectedBrand | string | any;
  categoryHandle?: string;
  cities: Array<ICitiesResponseObject>;
}

export interface ICoreCategoryGlobal {
  id: number | string;
  title: string;
  value?: string;
}

export interface IUserDetailsResponseObject {
  accountStatus: string;
  countryCode: string;
  fullName: string;
  id: string;
  nationalId: string;
  phoneNumber: string;
  email: string;
}

export interface ICreateUpdateRiderManagementUserNormalizedReq {
  id?: string;
  fullName: string;
  accountStatus?: string;
  countryCode?: string;
  nationalId: string;
  email?: string;
  phoneNumber: string;
  password?: string;
  confirmPassword?: string;
  title: string;
  status?: string;
  userId: string;
  jobType: string[];
  subType: string;
  warehouseId: string;
}

export interface ICampaignCSVData {
  customerId: string;
  target: number;
  rewardAmount: number;
}

export interface ICreateCampaignRequestPayload {
  campaignImage?: FormData;
  brandIds?: string[];
  imageId?: string;
  title: string;
  description: string;
  type: string;
  duration: number;
  recurrence: number;
  startDate: string;
  customers: ICampaignCSVData[];
}

export interface IAddUpdateCampaignPageProps extends RouteComponentProps {
  backButtonHandler: (isAddUpdate?: any) => void | {};
  createCampaign: (payload: any) => void;
  updateCampaign: (campaignId: string) => void;
  fetchProductBrands: () => void;
  productBrands: IMultiSelectOption[];
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCampaignCreated: boolean;
  isCampaignUpdated: boolean;
  isEdit: boolean;
  campaign: ICampaign | undefined;
  dummyFileName?: string;
  dummyType?: ISearchSelectChange;
  dummyCSVData?: ICampaignCSVData[];
  dummyIsStatusChange?: boolean;
}

export interface IAddUpdateCnicVerificationPageProps
  extends RouteComponentProps {
  backButtonHandler: (isAddUpdate?: any) => void | {};
  verifyCnicData: (payload: ICnicVerificationRequestPayload) => void;
  fetchCnicVerificationData: (queryParams?: IGetQueryParams) => void;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCnicVerificationDataUpdated: boolean;
  isEdit: boolean;
  cnicVerificationData: ICnicVerification;
  dummyModalType?: string;
}

export interface IMultiSelectOption {
  id: string;
  value: string;
  label: string;
}

export interface ICampaignPageProps extends RouteComponentProps {
  createCampaign: (payload: ICreateCampaignRequestPayload) => void;
  fetchCampaigns: (queryParams?: IGetQueryParams) => void;
  updateCampaign: (campaignId: string) => void;
  fetchProductBrands: () => void;
  productBrands: IMultiSelectOption[];
  isLoading: boolean;
  pagination: any;
  campaigns: ICampaign[];
  isCampaignFetched: boolean;
  isCampaignFetchedError: boolean;
  isError: boolean;
  error: null | string | object;
  isCampaignCreated: boolean;
  isCampaignUpdated: boolean;
}

export interface ICnicVerificationPageProp extends RouteComponentProps {
  fetchCnicVerificationData: (queryParams?: IGetQueryParams) => void;
  verifyCnicData: (queryParams?: IGetQueryParams) => void;
  isLoading: boolean;
  pagination: any;
  cnicVerificationData: ICnicVerification[];
  isCnicVerificationDataFetched: boolean;
  isCnicVerificationDataFetchedError: boolean;
  isError: boolean;
  error: null | string | object;
  currentListPosition: number;
  isCnicVerified: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
}

export interface ICnicVerificationListProp {
  fetchCnicVerificationData: (queryParams?: IGetQueryParams) => void;
  updateCount: (count: number) => void;
  addUpdatePageHandler: (isEdit?: boolean, selectedOrder?: any) => void;
  changeListingFilter: (
    filerSelection: IIdValuePairResponse,
    filterType: string
  ) => void;
  listingFilter: IIdValuePairResponse;
  isLoading: boolean;
  cnicVerificationData: ICnicVerification[];
  isCnicVerificationDataFetched: boolean;
  isCnicVerificationDataFetchedError: boolean;
  isError: boolean;
  error: null | string | object;
  isCnicVerified: boolean;
  isVerificationDataAddedorUpdated: boolean;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  selectedCity: IIdValuePairResponse;
  selectedCustomerChannel: IIdValuePairResponse;
  retainedSearchText: string;
  pagination: any;
  currentListPosition: number;
}

export interface ICampaignListProps {
  fetchCampaigns: (queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    isEdit?: boolean,
    selectedOrder?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  campaigns: ICampaign[];
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isCampaignCreated: boolean;
  isCampaignUpdated: boolean;
  isCampaignFetched: boolean;
  isCampaignAddedorUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
}

export interface IFetchCampaignActionResponse {
  campaigns: ICampaign[];
  pagination: any;
  isPaginatedRes: boolean;
}

export interface IFetchCnicVerificationActionResponse {
  cnicVerificationData: ICnicVerification[];
  pagination: any;
  isPaginatedRes: boolean;
}

export interface ICampaign {
  id: string;
  campaignNumber: string;
  title: string;
  description: string;
  campaignStatus: string;
  type: string;
  duration: number;
  recurrence: number;
  startDate: string;
  endDate: string;
  brandIds?: string[];
  imageUrl?: string;
}

export interface ICnicImageActionResponse {
  base64: string;
}

export interface ICnicVerificationRequestPayload {
  customerId: string;
  status: string;
  expiryDate: number | null;
  dateOfBirth: number | null;
  kycFailureReason: string;
}

export interface ICnicVerification {
  nationalId: string;
  frontImageId: string;
  backImageId: string;
  verificationStatus: string;
  userImageId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  expiryDate: string;
  dateOfBirth: string;
  reason: string;
  status: string;
  customerChannel: string;
  storeName?: string;
  owner?: ownerInfo;
}

export interface ownerInfo {
  cnicBackImageId: string;
  cnicFrontImageId: string;
  dateOfBirth: string;
  expiryDate: string;
  id: string;
  name: string;
  nationalId: string;
  ownerImageId: string;
  phoneNumber: string;
  status: string;
}

export interface ICnicInfo {
  userId?: string;
  phoneNumber?: string;
  name?: string;
  nationalId: string;
  expiryDate: Date | null;
  dateOfBirth: Date | null;
  customerChannel: CUSTOMER_CHANNEL;
  handleDateChange: (fieldName: string, value: any) => void | {};
  userType: CNIC_VERIFITCATION_USER_TYPE;
  ownerStatus?: OWNER_VERIFICATION_STATUS;
}

export interface ICampaignInitialState {
  isLoading: boolean;
  pagination: any;
  campaigns: ICampaign[];
  isCampaignFetched: boolean;
  isCampaignFetchedError: boolean;
  isError: boolean;
  error: null | string | object;
  isCampaignCreated: boolean;
  isCampaignUpdated: boolean;
}

export interface ICnicVerificationInitialState {
  isLoading: boolean;
  pagination: any;
  cnicVerificationData: ICnicVerification[];
  isCnicVerificationDataFetched: boolean;
  isCnicVerificationDataFetchedError: boolean;
  isError: boolean;
  error: null | string | object;
  isCnicVerified: boolean;
}

export interface ICampaignCycle {
  startDate: Date;
  endDate: Date;
}

export interface IFetchZonalConfigResponse {
  status: string;
  town: string;
  id: string;
  name: string;
  zone: string;
  type: string;
  locationPolygonText: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
}

export interface IFetchZonalConfigNormalizedResponse {
  status: string;
  town: string;
  id: string;
  name: string;
  zone: string;
  type: string;
}

export interface ICreateZonalConfigPayload {
  id: string;
  city: string;
  type: string;
  zone: string;
  town: string;
  name: string;
  warehouse: string;
  status: string | boolean;
  channel: string;
}

export interface IFetchZonalConfigListActionResponse {
  pagination: number;
  isPaginatedRes: boolean;
  zonalConfigsData: Array<any>;
}

export interface IZonalConfigsInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isZonalConfigAdded: boolean;
  isFetchZonalConfigsLoading: boolean;
  isFetchZonalConfigsError: boolean;
  zonalConfigs: IFetchZonalConfigNormalizedResponse[];
  pagination: any;
  isZonalConfigUpdated: boolean;
  // zonalCongigDetails: IZonalConfigDetailResponseNormalized | {};
  isZonalConfigDetailsFetched: boolean;
  isZonalConfigByTypeFetched: boolean;
  isZonalConfigByTypeFetchError: boolean;
  // zonalConfigsByType: IZonalConfigBasketDetailResponse[] | IZonalConfigDetailResponse[];
  warehouseCategories: Array<IWarehouseCategory>;
  isWarehouseCategoriesFetched: boolean;
  zonalConfigChildZones: Array<IWarehouseCategory>;
  isZonalConfigChildZonesFetched: boolean;
  zonalConfigTowns: Array<IWarehouseCategory>;
  isZonalConfigTownsFetched: boolean;
  isZonalConfigWarehouseNameFetched: boolean;
  zonalConfigWarehouseName: object;
  zonalConfigChannelName: string | null;
  isFetchCustomerChannelLoading: boolean;
}

export interface IZonalConfigPageProps extends RouteComponentProps {
  fetchZonalConfigs: (queryParams?: IGetQueryParams) => void;
  createZonalConfig: (payload: ICreateZonalConfigPayload) => void;
  zonalConfigs: Array<IFetchZonalConfigNormalizedResponse>;
  pagination: any;
  isFetchZonalConfigsLoading: boolean;
  isFetchZonalConfigsError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  updateZonalConfig: (
    id: string,
    zoneType: string,
    payload: IZonalConfigPayload
  ) => void;
  isZonalConfigAdded: boolean;
  isZonalConfigUpdated: boolean;
  zonalConfigDetails: IZonalConfigPayload;
  isZonalConfigDetailsFetched: boolean;
  getZonalConfigDetails: (id: string, cityId: string) => void;
  clearZonalConfigDetails: () => void;
  isZonalConfigByTypeFetched: boolean;
  isZonalConfigByTypeFetchError: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  zonalConfigUpload: (cityId: string, payload: FormData, url: string) => void;
  zonalCSVBatchUpload: (payload: FormData) => void;
  isZonalConfigUploaded: boolean;
  isZonalConfigUploading: boolean;
  isZonalConfigUploadingError: boolean;
  isZonalConfigBatchUploaded: boolean;
  isZonalConfigBatchUploading: boolean;
  isZonalConfigBatchUploadingError: boolean;
  getWarehouseCategories: (queryParams?: IGetQueryParams) => void | {};
  warehouseCategories: Array<IWarehouseCategory>;
  isWarehouseCategoriesFetched: boolean;
  getZonalConfigChildZones: (id: string) => void | {};
  zonalConfigChildZones: Array<IWarehouseCategory>;
  isZonalConfigChildZonesFetched: boolean;
  getZonalConfigTowns: (id: string) => void | {};
  zonalConfigTowns: Array<IWarehouseCategory>;
  isZonalConfigTownsFetched: boolean;
  getZonalConfigWarehouse: (
    id: string,
    zoneType: string,
    zoneStatus: boolean
  ) => void | {};
  isZonalConfigWarehouseNameFetched: boolean;
  zonalConfigWarehouseName: object;
  getBulkCustomerDetailsByIdAction: (ids: string[]) => void | {};
  clearBulkCustomerDetailsAction: () => void | {};
  bulkCustomerDetails: Record<string, IGetCustomerNewDetailResponse>;
  isBulkCustomerDetailsFetched: boolean;
  getZonalConfigWarehouseListWithStorageBlocks: (
    id: string,
    zoneType: string
  ) => void | {};
  isZonalConfigWarehouseListWithStorageBlocksFetched: boolean;
  zonalConfigWarehouseListWithStorageBlocks: IWarehouseStorageBlock[];
  customerConfig: ICustomerConfigResponse;
  fetchCustomerConfig: () => void;
  getZoneCustomerChannelConfig: (cityId: string) => void;
  zonalConfigChannelName: string | null;
  isFetchCustomerChannelLoading: boolean;
}

export interface IAddUpdateZonalConfigtPageState {
  name: string;
  parentZoneId?: string;
  type?: string;
  warehouseId?: string;
  warehouseCityId?: string;
  zoneStatus?: string;
  warehouseByStorageBlockMap?: IWarehouseByStorageBlockMappingDto[];
  channel?: string;
}

export interface IWarehouseByStorageBlockMappingDto {
  storageBlock: string;
  warehouseId: string;
}

export interface IZonalConfigUpdatePayload {
  name: string;
  warehouseId?: string;
  warehouseCityId?: string;
  zoneStatus?: string;
}

export interface IZonalConfigListProps {
  currentLocation: any;
  fetchZonalConfigs: (cityId: string, queryParams?: IGetQueryParams) => void;
  addUpdatePageHandler: (
    cityObj: object,
    isEdit?: boolean,
    selectedOrder?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  zonalConfigs: Array<IFetchZonalConfigNormalizedResponse>;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isZonalConfigsAdded: boolean;
  isZonalConfigsUpdated: boolean;
  isZonalConfigsAddedorUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
  selectedCity?: IIdValuePairResponse | null;
  retainedListPosition?: number;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  zonalConfigsCityLevel: Array<IFetchZonalConfigNormalizedResponse>;
  zonalConfigUpload: (cityId: string, payload: FormData, url: string) => void;
  isZonalConfigUploading: boolean;
  isZonalConfigUploaded: boolean;
  isZonalConfigUploadingError: boolean;
  zonalCSVBatchUpload: (payload: FormData) => void;
}

export interface ISearchSelectChange {
  value: string;
  label: string;
}

export interface IPlanCreationPageProps {
  getWarehouseNamesForPlanCreation: () => void;
  wareHouseNames: IWarehousePayload[];
  downloadLocusCsv: (payload: IPlanCreation) => void;
  downloadPlanOutputCsv: (planId: string) => void;
  locusCsvFile: any;
  isCsvDownloaded: boolean;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  dummyValidation: boolean;
  dummyPlanCreationData: IPlanCreationState | null;
}

export interface IPlanCreationState {
  warehouseId: any;
  targetDate: string;
  planType: IMultiSelectOption[];
  customerChannel: IMultiSelectOption[];
  storeType: IMultiSelectOption[];
}

export interface IPlanCreation {
  warehouseId: any;
  targetDate: string;
  planType: string[];
  customerChannel: string[];
}

export interface IDeliveryDateCreationState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isEdit: boolean;
  orderReceivedEndTime: string;
  orderReceivedStartTime: string;
  expectedDeliveryAt: any;
  warehouseId: any;
  status: string;
  warehouseCategories: Array<IWarehouseCategory>;
  isWarehouseCategoriesFetched: boolean;
  isFetchWarehouseDeliveryDateConfig: boolean;
  warehouseDeliveryDateConfig: IAddUpdateDeliveryDatePageState | null;
  isWarehouseConfigAdded: boolean;
}

export interface IAddUpdateDeliveryDatePageState {
  warehouseId: string;
  orderReceivedStartTime: string;
  orderReceivedEndTime: string;
  expectedDeliveryAt: string;
  status: string;
}

export interface IAddUpdateDeliveryDatePageStateIdValue {
  warehouseId: IIdValuePairResponse;
  orderReceivedStartTime: string;
  orderReceivedEndTime: string;
  expectedDeliveryAt: string;
  status: boolean | DELIVERY_DATE_STATUS;
}

export interface IDeliveryDateCreationProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  dummyValidation: boolean;
  isEdit: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  getWarehouseCategories: (id: string) => Array<IWarehouseCategory> | [];
  warehouseCategories: Array<IWarehouseCategory>;
  isWarehouseCategoriesFetched: boolean;
  fetchWarehouseDeliveryDateConfig: (
    id: string
  ) => IAddUpdateDeliveryDatePageState | {};
  isFetchWarehouseDeliveryDateConfig: boolean;
  warehouseDeliveryDateConfig: IAddUpdateDeliveryDatePageState | null;
  createUpdateWarehouseDeliveryDateConfig: (
    payload: IAddUpdateDeliveryDatePageState
  ) => void;
  isWarehouseConfigAdded: boolean;
  submitDeliveryDatePayload: (payload: FormData) => void;
}

export interface ICreateUpdateMetrics {
  id?: string;
  cityId: string;
  coreMetrics: IMultiSelectInterface[] | string[];
  categoryMetrics: IMultiSelectInterface[] | string[];
}

export interface INormalizedMetrics {
  cityId: string;
  coreMetrics: string[];
  categoryMetrics: string[];
}

export interface IMetricsInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isMetricsUpdated: boolean;
  metricsDetails: null;
  isMetricsDetailsFetched: boolean;
  metricsDetailsFetched: null | ICreateUpdateMetrics;
  isCoreMetricsFetched: boolean;
  coreMetricsFetched: IMultiSelectInterface[];
  isCategoriesMetricsFetched: boolean;
  categoriesMetrics: IMultiSelectInterface[];
  isMetricsUploading: boolean;
  isMetricsUploadingError: boolean;
  isMetricsUploaded: boolean;
}

export interface IAddUpdateMetrics {
  isMetricsUpdated: boolean;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  updateMetrics: (payload: ICreateUpdateMetrics) => void;
  isMetricsAddedUpdated: boolean;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
  getMetrics: (id: string) => void;
  isMetricsDetailsFetched: boolean;
  metricsDetailsFetched: ICreateUpdateMetrics;
  getAllCoreMetrics: (queryParams?: IGetQueryParams) => void;
  isCoreMetricsFetched: boolean;
  coreMetricsFetched: IMultiSelectInterface | any;
  getCategoriesForMetrics: (id: string) => void;
  isCategoriesMetricsFetched: boolean;
  categoriesMetrics: IMultiSelectInterface[];
  metricsUpload: (payload: FormData, queryParams?: IGetQueryParams) => void;
  isMetricsUploading: boolean;
  isMetricsUploadingError: boolean;
  isMetricsUploaded: boolean;
}

export interface IMultiSelectInterface {
  id: string;
  name: string;
  title?: string;
}

export interface IMultiSelectInterfaceSourceNormalizer {
  id: IMultiSelectInterface;
  name: IMultiSelectInterface;
}

export interface ICategoriesForMetrics {
  categories: ICategoriesChildren;
}

interface ICategoriesChildren {}
export interface IOrderPriceBreakdown {
  walletAmount: number;
  creditAmount: number;
  cashAmount: number;
  orderNumber: string;
}

export interface ITopUpPage {
  dummyCity?: ISearchSelectChange;
  dummyLoadWallet?: boolean;
}

export interface IPaiyaTypeConfig {
  games: Array<IPaiyaTypeCategory> | [];
  variants: Array<IPaiyaTypeCategory> | [];
}

export interface IPaiyaConfigCreationState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isEdit: boolean;
  paiyaTypesList: any | [];
  isPaiyaTypesFetched: boolean;
  isPaiyaConfigAdded: boolean;
  isPaiyaConfigFetch: boolean;
  paiyaConfig: IPaiyaConfigPageState | null;
  // paiyaConfig: IAddUpdatePaiyaPageState | null;
  isGiftCsvLoading: boolean;
  isGiftCsvUploaded: boolean;
  isGiftCsvError: boolean;
  isStoreCsvLoading: boolean;
  isStoreCsvUploaded: boolean;
  isStoreCsvError: boolean;
  storeCsvError: null | string | object;
  giftCsvError: null | string | object;
  //payload
  cityId: any;
  paiyaId: any;
  giftCsvFile: any;
  storeCsvFile: any;
  giftCsvFileName: string | undefined;
  storeCsvFileName: string;
  dummyFileName?: string;
  mov: string;
  status: string;
}

export interface IAddUpdatePaiyaPageState {
  status: string;
  requirement: {
    type: string;
    value: string;
  };
}

export interface IPaiyaTypeCategory {
  id: number | string;
  title: string;
  value?: string;
  key?: string;
  label?: string;
  name?: string;
}

export interface IPaiyaConfigPageState {
  title?: string;
  id?: string;
  description?: string;
  status: string;
  requirement: IRequirement;
}
export interface IPaiyaPageCreationProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  dummyValidation: boolean;
  isEdit: boolean;

  fetchCities: () => void; //
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;

  fetchPaiyaTypes: () => Array<IPaiyaTypeCategory> | []; //function
  paiyaTypesList: any; //list
  isPaiyaTypesFetched: boolean; //boolean

  fetchPaiyaConfig: (gameVariantType: string, id: string) => {};
  isPaiyaConfigFetch: boolean;
  paiyaConfig: IPaiyaConfigPageState | null;

  isPaiyaConfigAdded: boolean;
  createPaiyaStoreCsv: (
    gameVariantType: string,
    cityId: string,
    payload: FormData,
    url: string
  ) => void;
  createPaiyaGiftCsv: (
    gameVariantType: string,
    cityId: string,
    payload: FormData,
    url: string
  ) => void;
  createPaiyaMovGameStatus: (
    gameVariantType: string,
    cityId: string,
    payload: IPaiyaMOVGameStatusPayload
  ) => void;
  fetchCustomerChannelAction: () => void;

  customerConfig: ICustomerConfigResponse | null;
  mov: string;
  status: string;
  cityId: any;
  paiyaId: any;
  giftCsvFile: any;
  giftCsvFileName: string;
  isGiftCsvLoading: boolean;
  isGiftCsvUploaded: boolean;
  isGiftCsvError: boolean;
  giftCsvError: null | string | object;
  isStoreCsvLoading: boolean;
  isStoreCsvUploaded: boolean;
  isStoreCsvError: boolean;
  storeCsvError: null | string | object;
  storeCsvFile: any;
  storeCsvFileName: string;
  dummyFileName?: string;
}

// warehouse interfaces

export interface IWarehouseStaffListingSuccessPayload {
  options: IGetQueryParams;
  staff: IWarehouseStaffListingResponse[];
}

export interface IWarehouseStaffListingResponse {
  userId: string;
  fullName: string;
  phoneNumber: string;
  title: string;
  warehouseId: string;
  status: string;
  jobTypes: string[];
}

export interface IWarehouseStaffInitialState {
  staff: IWarehouseStaffListingResponse[];
  isLoading: Boolean;
  isError: Boolean;
  error: null;
  isWarehouseStaffListFetched: Boolean;
  pagination: null;
  isWarehouseStaffUserDetailsFetched: Boolean;
  warehouseStaffUserDetails: IUserDetailsResponseObject | any;
  isWarehouseStaffUserAddUpdate: Boolean;
  isWarehouseStaffUpdated: Boolean;
  isWarehouseStaffCreated: Boolean;
  warehouseList: IWarehousePayload[] | any;
  jobTypesList: IMultiSelectDropdownPayload[];
}

export interface ICreateUpdateWarehouseStaffUserNormalizedReq {
  id?: string;
  fullName: string;
  accountStatus?: string;
  countryCode?: string;
  nationalId: string;
  email?: string;
  phoneNumber: string;
  password?: string;
  confirmPassword?: string;
  title: string;
  status?: string;
  userId: string;
  warehouseId: string;
  jobTypes: Array<string>;
}

export interface ICreateUpdateStaffRequestPayload {
  userId: string;
  fullName: string;
  phoneNumber: string;
  title: string;
  status: string | boolean;
  warehouseId: string;
  jobTypes: Array<string>;
}

export interface ICreateWarehouseStaffUserRequestPayload {
  id: string;
  userId: string;
  fullName: string;
  phoneNumber: string;
  title: string;
  password: string;
  confirmPassword?: string;
  nationalId: string;
  status?: string | boolean;
  email: string;
  warehouseId: string;
  jobTypes: Array<string>;
}

export interface IWarehouseStaffNormalized {
  userId: string;
  fullName: string;
  phoneNumber: string;
  status?: string;
  title: string;
  jobTypes: string[];
  warehouseId: string;
}

export interface IMultiSelectDropdownPayload {
  key: string;
  title: string;
  label: string;
}

export interface IUserCreateUpdatePayload {
  id: string | undefined;
  fullName: string;
  phoneNumber: string;
  password?: string;
  nationalId: string;
  email?: string;
  accountStatus: string;
  countryCode: string;
}

export interface IUserCreationsResponsePayload {
  id: string;
  fullName: string;
  phoneNumber: string;
  nationalId: string;
  email: string;
  accountStatus: string;
  countryCode: string;
}

export interface IFetchStaffActionResponse {
  pagination: any;
  isPaginatedRes: boolean;
  staff: Array<IWarehouseStaffListingResponse>;
}

export interface IFetchNewsfeedListResponse {
  id: string;
  title: string;
  description: string;
  enabled: any;
  content: INewsfeedContent[];
  cta: INewsfeedCta[];
  selectedCity?: IIdValuePairResponse | null;
}

export interface IAddUpdateNewsfeedPageResponse {
  id: string;
  title: string;
  description: string;
  status: boolean;
  content: INewsfeedContent[];
  contentId: string;
  contentUrl: string;
  contentType: string | ISelectedBrand | any;
  cta: INewsfeedCta[];
  ctaId?: string;
  ctaName: string;
  ctaAction: string;
}

interface INewsfeedContent {
  id?: string;
  url: string;
  type: string;
}

interface INewsfeedCta {
  id?: string;
  name: string;
  action: string;
}

export interface INewsfeedInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isNewsfeedListFetched: boolean;
  newsfeedListFetched: [];
  isFetchNewsfeedError: boolean;
}

export interface IFetchNewsfeedActionResponse {
  pagination: number;
  isPaginatedRes: boolean;
  newsfeedListsData: Array<any>;
}

export interface INewsfeedPageProps extends RouteComponentProps {
  getNewsfeedList: (queryParams?: IGetQueryParams) => void;
  isNewsfeedListFetched: boolean;
  isFetchNewsfeedError: boolean;
  newsfeedListFetched: any; //Will deifine interface once we get list
  createNewsfeed: (payload: ICreateNewsfeedPayload) => void;
  updateNewsfeed: (id: string, payload: ICreateNewsfeedPayload) => void;
  getPromoByType: (type: string) => void;
  getCommandoCategories: (
    isProductDetailPage: boolean,
    queryParams: IGetQueryParams
  ) => void;
  promos: Array<IFetchPromoNormalizedResponse>;
  pagination: any;
  isFetchPromosLoading: boolean;
  isFetchPromosError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isNewsfeedAdded: boolean;
  isNewsfeedUpdated: boolean;
  promoDetails:
    | IVolumetricPromoDetailResponseNormalized
    | IBasketPromoDetailResponseNormalized;
  isPromoDetailsFetched: boolean;
  fetchPromoDetails: (id: string) => void;
  clearPromoDetails: () => void;
  isPromoByTypeFetched: boolean;
  isPromoByTypeFetchError: boolean;
  promosByType:
    | IPromoBasketDetailResponse[]
    | IPromoDetailResponse[]
    | IDynamicPromoDetailResponse[]
    | any;
  commandoProductCategories: Array<ICategoryListingNormalizedData>;
  isFetchCategoryLoading: boolean;
  isFetchCategoryError: boolean;
  commandoCategoryError: null | string | object;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
}

export interface INewsfeedListProps {
  currentLocation: any;
  getNewsfeedList: (queryParams?: IGetQueryParams) => void;
  isNewsfeedListFetched: boolean;
  newsfeedListFetched: Array<IFetchNewsfeedListResponse>;
  addUpdatePageHandler: (
    cityObj: object,
    isEdit?: boolean,
    selectedOrder?: any,
    searchText?: string,
    currentScroll?: number
  ) => void;
  pagination: any;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isNewsfeedAdded: boolean;
  isNewsfeedUpdated: boolean;
  isNewsfeedAddedorUpdated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
  selectedCity?: IIdValuePairResponse | null;
  retainedListPosition?: number;
  fetchCities: () => void;
  citiesList: IIdValuePairResponse[];
  isCityListFetched: boolean;
}

export interface IAddUpdateNewsfeedProps extends RouteComponentProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isNewsfeedAdded: boolean;
  selectedNewsfeedItem: IFetchNewsfeedListResponse | null;
  createNewsfeed: (payload: ICreateNewsfeedPayload) => void;
  updateNewsfeed: (id: string, payload: ICreateNewsfeedPayload) => void;
  isEdit: boolean;
  backButtonHandler: (isAddUpdate?: any, currentLocation?: any) => void | {};
  isNewsfeedUpdated: boolean;
}

export interface Cta {
  name: string;
  action: string;
}

export interface ICreateNewsfeedPayload {
  id: string;
  title: string;
  description: string;
  enabled: boolean;
  content: INewsfeedContent[];
  cta: INewsfeedCta[] | null;
}

export interface IICreateNewsfeedKeyPayload {
  id: string;
  title: string;
  description: string;
  content: INewsfeedContent[];
  cta: INewsfeedCta[];
}

export interface IJobTypes {
  jobTypes: string[];
  subTypes: string[];
}

export interface IProductOptionalProperties {
  shelfLife: string;
}

export interface IProductVariantProperties {
  stackingHeight: string;
  dimensions: IDimensions;
}

export interface IDimensions {
  length: string;
  width: string;
  height: string;
}

export interface ILoggingViewerProps {
  createdAt: string | undefined;
  createdBy: string | undefined;
  updatedAt: string | undefined;
  updatedBy: string | undefined;
}

export interface IFilterPayload {
  id: string;
  title: string;
  description: string;
  filterMap: Map<string, Array<string>>;
  clientId: string;
}

export interface IDropDownResponse {
  id: string;
  title: string;
  value?: string;
  key?: string;
  label?: string;
}

export interface ICustomerChannelAttributesMap {
  [key: string]: {
    actualPrice: number;
    discountedPrice: number;
  };
}
export interface IEditableTableProps {
  customerChannel: ICustomerChannelAttributesMap | object;
  updateGrid: (data: ICustomerChannelAttributesMap) => void;
  roles?: string[];
}

export interface IPaiyaGift {
  title: string;
  type: IMultiSelectOption | any;
  image: string;
  value: string | number;
}

export interface IPaiyaGiftCreatePayload {
  type: string;
  title: string;
  details: {
    amount: number;
    variantId: string;
  };
}
export interface IPaiyaGiftsPageProps extends RouteComponentProps {
  createPaiyaGift: (payload: IPaiyaGiftCreatePayload) => void;
  paiyaGifts: Array<IPaiyaGift>;
  isPaiyaGiftsLoading: boolean;
  isPaiyaGiftsError: boolean;
  error: null | string | object;
  isLoading: boolean;
  isError: boolean;
  isPaiyaGiftCreated: boolean;
  getPaiyaGiftDetails: () => void;
  clearPaiyaGiftDetails: () => void;
  uploadImageAndCreatePaiyaGiftAction: (
    formData: FormData,
    payload: IPaiyaUploadNormalizer
  ) => void;
  fetchPaiyaGifts: (searchKey: string, giftType: string) => void;
}

export interface IPaiyaGiftsPageState {
  showAddUpdatePage: boolean;
  searchText: string;
  currentListPosition: number;
  selectedType: IIdValuePairResponse;
}

export interface IPaiyaGiftsListProps {
  fetchPaiyaGifts: (searchKey: string, giftType: string) => void;
  addUpdatePageHandler: (
    cityObj?: IIdValuePairResponse,
    searchText?: string,
    currentScroll?: number
  ) => void;
  //TODO PAIYA
  paiyaGifts: Array<IPaiyaGift>;
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPaiyaGiftCreated: boolean;
  currentListPosition: number;
  retainedSearchText: string;
  selectedType?: IIdValuePairResponse;
}

export interface IAddUpdatePaiyaGiftPageProps {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPaiyaGiftCreated: boolean;
  defaultPaiyaGift: {
    id: string;
    type: {
      id: string;
      label: string;
      type: string;
      value: string | number;
    };
    title: string;
    value: string | number;
    image: object;
  };
  createPaiyaGift: (payload: IPaiyaGiftCreatePayload) => any;
  backButtonHandler: (isAddUpdate?: any, currentLocation?: any) => void;
  uploadImageAndCreatePaiyaGiftAction: (
    payload: FormData,
    jsonData: any
  ) => void;
  clearPaiyaGiftDetails: () => any;
}

export interface IPaiyaUploadNormalizer {
  formData: FormData;
  payload: IPaiyaGiftCreatePayload;
}

interface IGiftImage {
  [key: string]: any;
}

export interface IAddUpdatePaiyaGiftPageState {
  type: IMultiSelectOption | any;
  title: string;
  value: number | string;
  image: IGiftImage | undefined;
}

export interface IPaiyaGiftInitialState {
  isLoading: boolean;
  isError: boolean;
  error: null | string | object;
  isPaiyaGiftsFetched: boolean;
  isPaiyaGiftCreated: boolean;
  paiyaGifts: Array<IPaiyaGift>;
}

export interface IRequirementValue {
  type: string;
  value: number;
}
export interface IRequirement {
  [key: string]: IRequirementValue;
}

export interface IPaiyaMOVGameStatusPayload {
  status: string;
  requirement: IRequirement;
}

export interface ISelectedMovRefObject {
  id: string;
  isChecked: boolean;
  label: string;
  title: string;
  value: number;
}
export interface IStorageBlock {
  value: string;
  label: string;
}
export interface IWarehouseStorageBlock {
  id: string;
  value: string;
  label: string;
  storageBlocks: IStorageBlock[];
}

export enum Vertical {
  MARKETPLACE,
  PRIME,
}
